import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { FormsServiceService } from '../../../api/services/forms-service.service';
import { CommonService } from '../../../api/services/common.service';
import { CommonModule } from '@angular/common';
import { InputTextFieldComponent } from '../../components/input-text-field/input-text-field.component';
import { environment } from '../../../../environments/environment';
import { ButtonsComponent } from '../../components/buttons/buttons.component';
import { ViewCardComponent } from '../../components/view-card/view-card.component';
import { DataViewWithLoaderComponent } from '../../components/data-view-with-loader/data-view-with-loader.component';
import { WorkflowService } from '../../../api/services/workflow.service';
import { DomainWithTagsComponent } from '../../components/domain-with-tags/domain-with-tags.component';
import { ToastrService } from 'ngx-toastr';
import { InputSearchFieldsComponent } from '../../components/input-search-fields/input-search-fields.component';
import { DropdownSelectComponent } from '../../components/dropdown-select/dropdown-select.component';
import { DomainRowsComponent } from '../../components/domain-rows/domain-rows.component';
import { PlaceholderWithTextComponent } from '../../components/placeholder-with-text/placeholder-with-text.component';
import { PhoneNumberComponent } from '../../components/phone-number/phone-number.component';
import { CheckboxTypeThreeComponent } from '../../components/checkbox-type-three/checkbox-type-three.component';
import { CheckboxTypeOneComponent } from '../../components/checkbox-type-one/checkbox-type-one.component';
import { ProjectsCardComponent } from '../../components/projects-card/projects-card.component';
import { SearchWithInputDataComponent } from '../../components/search-with-input-data/search-with-input-data.component';
import { LabelTypeTwoComponent } from '../../components/label-type-two/label-type-two.component';
import { Subject, takeUntil } from 'rxjs';
import { AuthService } from '../../../api/services/auth.service';
import { FORM_ID } from '../../../helpers/form-id.enum';
import { RadioButtonsComponent } from '../../components/radio-buttons/radio-buttons.component';
import { DomainInputComponent } from '../../components/domain-input/domain-input.component';
import { DropdownWithSearchComponent } from '../../components/dropdown-with-search/dropdown-with-search.component';
import { LabelTypeThreeComponent } from '../../components/label-type-three/label-type-three.component';
import { ReassignmentTableComponent } from '../../components/reassignment-table/reassignment-table.component';
import { SwitchFieldComponent } from '../../components/switch-field/switch-field.component';
import { SearchListComponent } from '../../components/search-list/search-list.component';
import { InputLabelComponent } from '../../components/input-label/input-label.component';
import { ResourcesCardComponent } from '../../components/resources-card/resources-card.component';
import { SwitchStatusComponent } from '../../components/switch-status/switch-status.component';
import { AccessViewCardComponent } from '../../components/access-view-card/access-view-card.component';
import { InputSearchIntegrationComponent } from '../../components/input-search-integration/input-search-integration.component';
import { FilterDropdownComponent } from '../../components/filter-dropdown/filter-dropdown.component';
import { InputWithCheckboxComponent } from '../../components/input-with-checkbox/input-with-checkbox.component';
import { FileUploadsComponent } from '../../components/file-uploads/file-uploads.component';
import { CheckboxTextComponent } from '../../components/checkbox-text/checkbox-text.component';
import { FileUploadComponent } from '../../components/file-upload/file-upload.component';
import { UserInviteComponent } from '../../components/user-invite/user-invite.component';
import { RoleDeleteImpactComponent } from '../../components/role-delete-impact/role-delete-impact.component';

@Component({
  selector: 'app-modal-renderer',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextFieldComponent,
    ButtonsComponent,
    ViewCardComponent,
    DataViewWithLoaderComponent,
    DomainWithTagsComponent,
    InputSearchFieldsComponent,
    DropdownSelectComponent,
    PlaceholderWithTextComponent,
    PhoneNumberComponent,
    CheckboxTypeThreeComponent,
    CheckboxTypeOneComponent,
    ProjectsCardComponent,
    SearchWithInputDataComponent,
    LabelTypeTwoComponent,
    FileUploadsComponent,
    CheckboxTextComponent,
    RadioButtonsComponent,
    DomainInputComponent,
    DropdownWithSearchComponent,
    LabelTypeThreeComponent,
    ReassignmentTableComponent,
    SwitchFieldComponent,
    SearchListComponent,
    InputLabelComponent,
    ResourcesCardComponent,
    SwitchStatusComponent,
    AccessViewCardComponent,
    InputSearchIntegrationComponent,
    FilterDropdownComponent,
    InputWithCheckboxComponent,
    FileUploadComponent,
    UserInviteComponent,
    RoleDeleteImpactComponent,
  ],
  templateUrl: './modal-renderer.component.html',
  styleUrl: './modal-renderer.component.css',
})
export class ModalRendererComponent {
  @Input() nodeId: any;
  @Input() recordID: any;
  @Input() taskId: any;
  @Input() workflowData: any;
  @Input() workflowId: any;
  @Input() activeModalContext: any;
  @Input() startDate: any;
  @Input() record: any;
  @Input() taskData: any;
  @Input() isFilterApply: any;
  @Input() labelAbove: any;
  @Input() showTags: any;
  @Input() isHeader: any;
  @Input() disableFields: any;
  @Input() actionableStatusEdit: any;
  @Input() isActionableFilterApply: any;
  @Input() disabledBtn = false;
  @Input() noRecord: any;
  @Input() recordIDs: any;
  @Input() labelText: any;
  @Input() twoGridColumn: any;
  @Input() isRiskFilterApply: any;
  @Input() allColsTextarea: any;
  @Input() isSecurityFilterApply: any;
  @Input() selectedRole: any;
  @Output() formSaved = new EventEmitter<any>();
  @Output() closeModal = new EventEmitter<void>();
  @Output() header = new EventEmitter<string>();
  @Output() loadData = new EventEmitter<{ formId: string; options?: any }>();
  @Output() clearAll = new EventEmitter<{ formId: string; options?: any }>();
  @Output() onFilterApplied = new EventEmitter<{
    formId: string;
    options: any;
  }>();
  @Output() onActionableFilterApplied = new EventEmitter<{
    formId: string;
    options: any;
  }>();
  @Output() clearActionableAll = new EventEmitter<{
    formId: string;
    options: any;
  }>();
  @Output() checkPollingServiceForError = new EventEmitter<{
    value: any;
  }>();
  @Output() openReassigneModal = new EventEmitter<any>();
  @Output() openSuccessModal = new EventEmitter<any>();
  @Output() clickedOnPrevious = new EventEmitter<{}>();
  @ViewChild('InputTextFieldComponent')
  InputTextFieldComponent!: InputTextFieldComponent;
  @ViewChildren(DomainRowsComponent)
  DomainRowsComponent!: QueryList<DomainRowsComponent>;
  @ViewChild(DomainWithTagsComponent)
  DomainWithTagsComponent!: DomainWithTagsComponent;
  @ViewChild(DomainInputComponent)
  DomainInputComponent!: DomainInputComponent;
  @ViewChild('InputSearchFieldsComponent')
  InputSearchFieldsComponent!: InputSearchFieldsComponent;
  @ViewChild(ProjectsCardComponent)
  ProjectsCardComponent!: ProjectsCardComponent;
  @ViewChild(CheckboxTypeThreeComponent)
  CheckboxTypeThreeComponent!: CheckboxTypeThreeComponent;
  @ViewChildren(InputSearchFieldsComponent)
  inputSearchFields!: QueryList<InputSearchFieldsComponent>;
  @ViewChildren(InputSearchIntegrationComponent)
  inputSearchIntegrations!: QueryList<InputSearchIntegrationComponent>;
  endpoint = environment.api_endpoint;
  formData: any;
  formFields: any;
  footerFields: any;
  saveForm!: FormGroup;
  visibleFields: { [fieldName: string]: boolean } = {};
  formPayload: any;
  isLoading: boolean = false;
  isFormLoading: boolean = false;
  isShowButton: any;
  hasDataViewLoader: boolean = false;
  updatedWorkflow: any;
  @Output() formReady = new EventEmitter<void>();
  skipWorkflowSave: boolean = false;
  @ViewChild('DataViewWithLoaderComponent')
  dataView!: DataViewWithLoaderComponent;
  @Output() stopPollingRequest = new EventEmitter<void>();
  private destroy$ = new Subject<void>();
  private formRebuild$ = new Subject<void>();
  hasDomainError: any;
  firstFocusFieldName: any;
  initialFormValue: any;
  isDisabled: boolean = true;
  domainTagsForSubmit: string[] = [];
  subItemData: any;
  selectedTasksCount = 0;
  /** Tracks whether the comment field label should show the required asterisk dynamically */
  commentRequired: boolean = false;
  @ViewChildren(DropdownSelectComponent)
  dropdownSelect!: QueryList<DropdownSelectComponent>;
  @ViewChildren(DropdownWithSearchComponent)
  dropdownWithSearch!: QueryList<DropdownWithSearchComponent>;
  initialRoleFromResponse: any = null;
  profileResponse: any;
  @Input() currentSelectedName: any;

  getSelectedRoleValue(): string {
    const isAdd =
      this.recordIDs === 'add' ||
      this.recordID === 'add' ||
      this.activeModalContext?.recordID === 'add';

    if (isAdd) {
      return '';
    }

    const role =
      this.selectedRole ||
      this.activeModalContext?.selectedRole ||
      this.activeModalContext?.role ||
      this.activeModalContext?.roleName ||
      this.activeModalContext?.deleteItem?.role ||
      this.activeModalContext?.deleteItem?.roleName ||
      this.activeModalContext?.item?.role ||
      this.activeModalContext?.item?.roleName ||
      this.record?.role ||
      this.record?.roleName ||
      this.taskData?.role ||
      '';

    if (role) {
      return typeof role === 'object'
        ? role.role || role.name || ''
        : String(role);
    }

    if (this.formData?.formCollection?.formName === 'Delete Role') {
      return (
        this.activeModalContext?.deleteItem?.name ||
        this.activeModalContext?.name ||
        this.activeModalContext?.defaultRole ||
        'SecOps'
      );
    }

    return '';
  }

  get permissions(): any {
    return this.formData?.formCollection?.permissions;
  }

  get hasPermissions(): boolean {
    const perm = this.permissions;
    if (perm === null || perm === undefined) return false;
    if (typeof perm === 'string') return perm.trim().length > 0;
    if (Array.isArray(perm)) return perm.length > 0;
    if (typeof perm === 'object') return Object.keys(perm).length > 0;
    return false;
  }

  get permissionList(): string[] {
    const perm = this.permissions;
    if (Array.isArray(perm)) {
      return perm.map((p: any) =>
        typeof p === 'object' ? JSON.stringify(p) : String(p),
      );
    }
    if (typeof perm === 'string' && perm.includes(',')) {
      return perm
        .split(',')
        .map((s) => s.trim())
        .filter((s) => s.length > 0);
    }
    return [];
  }

  get showPermissionBadges(): boolean {
    return this.permissionList.length > 0;
  }

  get formattedPermissions(): string {
    const perm = this.permissions;
    if (!perm) return '';
    if (typeof perm === 'string') return perm;
    if (Array.isArray(perm)) {
      return perm
        .map((p: any) =>
          typeof p === 'object' ? JSON.stringify(p) : String(p),
        )
        .join(', ');
    }
    if (typeof perm === 'object') {
      return Object.entries(perm)
        .map(([k, v]) => `${k}: ${v}`)
        .join(', ');
    }
    return String(perm);
  }
  constructor(
    private formService: FormsServiceService,
    private fb: FormBuilder,
    private workflowService: WorkflowService,
    private toaster: ToastrService,
    private auth: AuthService,
    private authService: AuthService,
    private commonService: CommonService,
  ) {}

  ngOnInit() {
    const isTargetWorkflow =
      this.workflowId === '68c3ed3d45a7a695efb493f5' ||
      this.workflowData?._id === '68c3ed3d45a7a695efb493f5' ||
      (typeof window !== 'undefined' &&
        window.location.href.includes('68c3ed3d45a7a695efb493f5'));

    if (!isTargetWorkflow) {
      this.getProfileDetails();
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.formRebuild$.complete();
  }

  ngOnChanges() {
    const roleVal = this.getSelectedRoleValue();
    if (roleVal) {
      if (!this.activeModalContext) {
        this.activeModalContext = {};
      }
      this.activeModalContext.selectedRole = roleVal;
      if (!this.activeModalContext.role) {
        this.activeModalContext.role = this.initialRoleFromResponse || roleVal;
      }
      if (this.saveForm?.get('role')) {
        const currentRole = this.saveForm.get('role')?.value;
        if (
          !currentRole ||
          (typeof currentRole !== 'object' && !this.initialRoleFromResponse)
        ) {
          this.saveForm
            .get('role')
            ?.setValue(this.initialRoleFromResponse || roleVal);
        }
      }
    }

    if (
      this.isActionableFilterApply &&
      this.saveForm &&
      this.activeModalContext
    ) {
      Object.keys(this.saveForm.controls).forEach((fieldName) => {
        let val = this.activeModalContext[fieldName];
        if (fieldName === 'status') {
          val =
            this.activeModalContext.actionableStatus ??
            this.activeModalContext.status ??
            val;
        } else if (fieldName === 'assigned') {
          val =
            this.activeModalContext.assigned ??
            this.activeModalContext.assignedUser ??
            val;
        } else if (fieldName === 'risk' && val === undefined) {
          val = this.activeModalContext.riskStatus;
        } else if (fieldName === 'riskStatus' && val === undefined) {
          val = this.activeModalContext.risk;
        } else if (fieldName === 'impact' && val === undefined) {
          val = this.activeModalContext.riskImpact;
        } else if (fieldName === 'assetType' && val === undefined) {
          val = this.activeModalContext.asset_type;
        } else if (fieldName === 'asset_type' && val === undefined) {
          val = this.activeModalContext.assetType;
        }
        if (val !== undefined && val !== null) {
          this.saveForm.get(fieldName)?.setValue(val);
        }
      });
    }

    if (
      this.footerFields?.length &&
      (this.activeModalContext?.clickedButton === 'EDIT' ||
        this.activeModalContext?.type === 'edit')
    ) {
      this.footerFields = this.footerFields.map((btn: any) => {
        if (
          btn.displayName?.toLowerCase() === 'invite' ||
          btn.componentId === 'applyButton' ||
          btn.fieldName === 'inviteButton' ||
          (!this.isNonSubmitAction(btn) && btn.displayName !== 'Cancel')
        ) {
          return { ...btn, displayName: 'Save' };
        }
        return btn;
      });
    }

    const isBulkUpdate = this.activeModalContext?.bulkUpdate === true;
    if (isBulkUpdate) {
      this.loadForm(this.nodeId, isBulkUpdate);
      return;
    }
    if (this.recordIDs && this.activeModalContext?.subItemData != undefined) {
      // If formFields not loaded yet → load form structure first
      if (!this.formFields || this.formFields.length === 0) {
        this.loadForm(this.nodeId, 0); // load only structure
        this.subItemData = this.activeModalContext.subItemData;
        this.buildForm();
        return;
      }
    }
    const isAdd =
      this.recordIDs === 'add' ||
      this.recordID === 'add' ||
      this.activeModalContext?.recordID === 'add';
    const effectiveRecordIDs = isAdd ? 0 : this.recordIDs;
    const effectiveRecordID = isAdd ? 0 : this.recordID;

    // 🔥 If subItemData exists → do NOT fetch
    if (this.nodeId && this.recordIDs && !this.recordID) {
      this.loadForm(this.nodeId, effectiveRecordIDs);
    } else if (this.nodeId && this.recordID && !this.recordIDs) {
      this.loadForm(this.nodeId, effectiveRecordID);
    } else if (this.nodeId) {
      this.loadForm(
        this.nodeId,
        this.noRecord === 'isNotShow' ? 'isNotShow' : 0,
      );
    }
  }

  /** Function to load the form with the formId */
  loadForm(formId: string, recordId?: any) {
    this.formService.loadFormData(formId, recordId).subscribe({
      next: (data) => {
        this.formData = data.data;

        const isAdd =
          this.recordIDs === 'add' ||
          this.recordID === 'add' ||
          this.activeModalContext?.recordID === 'add';

        if (isAdd) {
          this.initialRoleFromResponse = null;
          if (this.formData?.formFields) {
            const roleField = this.formData.formFields.find(
              (f: any) => f.fieldName === 'role',
            );
            if (roleField) {
              roleField.value = '';
              roleField.defaultValue = '';
            }
          }
        } else {
          const rawRoleField = this.formData?.formFields?.find(
            (f: any) => f.fieldName === 'role',
          );
          const apiRoleVal = rawRoleField?.value;
          const hasApiRoleValue =
            apiRoleVal !== undefined &&
            apiRoleVal !== null &&
            apiRoleVal !== '' &&
            !(Array.isArray(apiRoleVal) && apiRoleVal.length === 0);

          if (hasApiRoleValue) {
            const unwrappedApiRole = Array.isArray(apiRoleVal)
              ? apiRoleVal.length > 0
                ? apiRoleVal[0]
                : null
              : apiRoleVal;
            if (unwrappedApiRole && typeof unwrappedApiRole === 'object') {
              this.initialRoleFromResponse = unwrappedApiRole;
            } else {
              this.initialRoleFromResponse = null;
            }
          } else {
            this.initialRoleFromResponse = null;
          }
        }

        const selectedRole = this.getSelectedRoleValue();
        if (selectedRole) {
          if (!this.activeModalContext) {
            this.activeModalContext = {};
          }
          this.activeModalContext.selectedRole = selectedRole;
          if (!this.activeModalContext.role) {
            this.activeModalContext.role =
              this.initialRoleFromResponse || selectedRole;
          }
        }

        const recId =
          this.recordID ||
          recordId ||
          this.activeModalContext?.recordID ||
          this.activeModalContext?.recordId ||
          this.activeModalContext?._id ||
          this.activeModalContext?.deleteItem?._id ||
          this.activeModalContext?.item?._id ||
          '';

        if (this.formData?.formCollection && recId) {
          this.formData.formCollection.recordId = String(recId);
        }

        if (this.formData && this.formData.sseConfig) {
          const catCode =
            this.activeModalContext?.selectedOption?.categoryCode ||
            this.activeModalContext?.categoryCode ||
            '';
          const replaceConfigUrls = (configObj: any) => {
            if (configObj && typeof configObj.apiUrl === 'string') {
              configObj.apiUrl = configObj.apiUrl
                .replace(/\{\{categoryCode\}\}/g, catCode)
                .replace(/\{\{integrationProfileRecordID\}\}/g, String(recId))
                .replace(/\{\{integrationProfileRecordId\}\}/g, String(recId));
            }
          };
          replaceConfigUrls(this.formData.sseConfig.onFailure);
          replaceConfigUrls(this.formData.sseConfig.onSuccess);
          replaceConfigUrls(this.formData.sseConfig.onTimeout);
        }
        if (this.formData?.formFields) {
          const defaultFormId =
            this.formData?.formCollection?.fieldCollectionName || formId || '';
          this.formData.formFields.forEach((f: any) => {
            if (!f.formId && defaultFormId) {
              f.formId = defaultFormId;
            }
          });

          let fieldsStr = JSON.stringify(this.formData.formFields);
          if (recId) {
            fieldsStr = fieldsStr
              .replace(/\{\{integrationProfileRecordID\}\}/g, String(recId))
              .replace(/\{\{integrationProfileRecordId\}\}/g, String(recId))
              .replace(/\{\{integrationProfileID\}\}/g, String(recId))
              .replace(/\{\{integrationProfileId\}\}/g, String(recId));
          }
          if (selectedRole) {
            fieldsStr = fieldsStr.replace(
              /\{\{selectedRole\}\}/g,
              selectedRole,
            );
          }
          this.formData.formFields = JSON.parse(fieldsStr);

          const isTargetIntegrationForm =
            formId === '6a6310c80e3b3a9926943566' ||
            this.nodeId === '6a6310c80e3b3a9926943566' ||
            defaultFormId === '6a6310c80e3b3a9926943566' ||
            this.activeModalContext?.formId === '6a6310c80e3b3a9926943566';

          if (isTargetIntegrationForm) {
            this.formData.formFields?.forEach((f: any) => {
              if (
                typeof f.defaultValue === 'string' &&
                (f.defaultValue === '{{integrationProfileRecordId}}' ||
                  f.defaultValue.includes('{{integrationProfileRecordId}}'))
              ) {
                f.defaultValue = f.defaultValue.replace(
                  /\{\{integrationProfileRecordId\}\}/g,
                  '6a630b2a0e3b3a9926943534',
                );
              }
            });
          }

          if (selectedRole) {
            const roleField = this.formData.formFields.find(
              (f: any) => f.fieldName === 'role',
            );
            if (roleField) {
              if (this.initialRoleFromResponse) {
                roleField.value = this.initialRoleFromResponse;
                roleField.defaultValue = this.initialRoleFromResponse;
              } else if (!isAdd && !roleField.value) {
                roleField.value = selectedRole;
                roleField.defaultValue = selectedRole;
              }
            }
          }
        }
        this.formFields = this.formData?.formFields;

        if (
          (formId === '68d3e4b82309babcadb8fc17' ||
            formId === FORM_ID.ACTIONABLE_FILTER) &&
          Array.isArray(this.formFields)
        ) {
          const impactField = this.formFields.find(
            (f: any) => f.fieldName === 'impact',
          );
          if (impactField) {
            impactField.multiselect = true;
          }
        }

        if (
          (formId === '68d3e4b82309babcadb8fc17' ||
            formId === FORM_ID.ACTIONABLE_FILTER) &&
          Array.isArray(this.formFields)
        ) {
          const assetCategoriesField = this.formFields.find(
            (f: any) => f.fieldName === 'assetCategories',
          );
          if (assetCategoriesField) {
            if (!assetCategoriesField.options) assetCategoriesField.options = {};
            if (!assetCategoriesField.options.source)
              assetCategoriesField.options.source = {};
            assetCategoriesField.options.source.formID =
              '6a97f32d6dbb4bbc078d471e';
            assetCategoriesField.options.isStatic = false;
          }
        }

        //  if (
        //   (formId === FORM_ID.TASK_FILTER ||
        //     formId === '68862dc7fe2c882fe8d21e9d' ||
        //     formId === FORM_ID.MY_TASK_FILTER ||
        //     formId === '6a3e188423bf07d3d695d9a1') &&
        //   Array.isArray(this.formFields)
        // )
        // Reorder task filter fields: domain first, framework last
        if (formId === FORM_ID.TASK_FILTER && Array.isArray(this.formFields)) {
          const domainField = this.formFields.find(
            (f: any) => f.fieldName === 'domainSubdomainMappings',
          );
          const frameworkField = this.formFields.find(
            (f: any) =>
              f.fieldName === 'framework' || f.fieldName === 'frameworks',
          );
          const rest = this.formFields.filter(
            (f: any) =>
              f.fieldName !== 'domainSubdomainMappings' &&
              f.fieldName !== 'framework' &&
              f.fieldName !== 'frameworks',
          );
          this.formFields = [
            ...(domainField ? [domainField] : []),
            ...rest,
            ...(frameworkField ? [frameworkField] : []),
          ];
        }
        this.footerFields = (this.formData?.footerFields || []).map(
          (btn: any) => {
            if (
              (this.activeModalContext?.clickedButton === 'EDIT' ||
                this.activeModalContext?.type === 'edit') &&
              (btn.displayName?.toLowerCase() === 'invite' ||
                btn.componentId === 'applyButton' ||
                btn.fieldName === 'inviteButton' ||
                (!this.isNonSubmitAction(btn) && btn.displayName !== 'Cancel'))
            ) {
              return { ...btn, displayName: 'Save' };
            }
            return { ...btn };
          },
        );
        this.header.emit(this.formData?.formCollection?.formDescription);
        this.buildForm();
        this.updateButtonState();
        // this.resetComment('comment');
        if (
          formId !== '69a5266ed692ed8802aec09b' &&
          formId !== '69a562256b183b97d7e060ac'
        ) {
          this.resetComment('comment');
        }
        this.resetData('searchUser');
        this.setFirstFocusField();
        if (
          this.formData?.sseConfig?.integration?.authUrl &&
          this.formData?.sseConfig?.integration?.authUrl != ''
        ) {
          this.navigateOAuth(this.formData.sseConfig, this.nodeId);
        }
      },
      error: (err) => console.error('Error loading form JSON:', err),
    });
  }

  isFirstFilterField(field: any): boolean {
    const first = this.formFields?.find(
      (f: any) => f.componentId === 'filterDropdown',
    );
    return first?.fieldName === field.fieldName;
  }

  /**
   * Dynamically builds the reactive form with controls, validators,
   * visibility rules, and special handling for OTP and tag-based fields.
   */
  buildForm() {
    const group: { [key: string]: any } = {};
    const dynamicallyControlledFields = new Set<string>();

    this.formFields?.forEach((f: any) => {
      if (f.fieldName === 'mappedStandards.standardName') {
        f.fieldName = 'mappedStandards_standardName';
      }
    });

    const isTargetIntegrationForm =
      this.nodeId === '6a6310c80e3b3a9926943566' ||
      this.formData?.formFields?.[0]?.formId === '6a6310c80e3b3a9926943566' ||
      this.activeModalContext?.formId === '6a6310c80e3b3a9926943566' ||
      this.formFields?.some((f: any) => f.formId === '6a6310c80e3b3a9926943566');

    if (isTargetIntegrationForm) {
      this.formFields?.forEach((f: any) => {
        if (
          typeof f.defaultValue === 'string' &&
          (f.defaultValue === '{{integrationProfileRecordId}}' ||
            f.defaultValue.includes('{{integrationProfileRecordId}}') ||
            f.defaultValue.includes('{{integrationProfileRecordID}}'))
        ) {
          f.defaultValue = f.defaultValue
            .replace(/\{\{integrationProfileRecordId\}\}/g, '6a630b2a0e3b3a9926943534')
            .replace(/\{\{integrationProfileRecordID\}\}/g, '6a630b2a0e3b3a9926943534');
        }
      });
    }

    // Track dynamically controlled fields
    this.formFields?.forEach((field: any) => {
      if (Array.isArray(field.fieldDependencies)) {
        field.fieldDependencies.forEach((dependency: any) => {
          if (
            dependency.trigger === 'onValueChange' &&
            Array.isArray(dependency.condition)
          ) {
            dependency.condition.forEach((cond: any) => {
              if (Array.isArray(cond.actions)) {
                cond.actions.forEach((action: any) => {
                  if (action.targetField) {
                    dynamicallyControlledFields.add(action.targetField);
                  }
                });
              }
            });
          }
        });
      }
    });

    // Create form controls
    this.formFields?.forEach((field: any) => {
      this.visibleFields[field.fieldName] = !dynamicallyControlledFields.has(
        field.fieldName,
      );

      if (
        [
          'label',
          'button',
          'grid',
          'video',
          'noData',
          'roleDeleteImpact',
          'roleImpactCard',
          'deleteRoleImpact',
          'roleImpact',
          'card',
        ].includes(field.fieldType) ||
        field.componentId === 'roleDeleteImpact'
      ) {
        return;
      }

      const validators = [];
      const validationRules = Array.isArray(field.validationRules)
        ? field.validationRules
        : [];

      if (
        field.isRequired &&
        field.fieldType !== 'hidden' &&
        !dynamicallyControlledFields.has(field.fieldName)
      ) {
        validators.push((control: AbstractControl) => {
          const value = control.value;

          // null
          if (value === null || value === undefined) {
            return { required: true };
          }

          // empty string
          if (typeof value === 'string' && value.trim() === '') {
            return { required: true };
          }

          // empty array (multi-select case)
          if (Array.isArray(value) && value.length === 0) {
            return { required: true };
          }

          return null;
        });
      }

      const minLength = validationRules.find(
        (v: any) => v.type === 'minLength',
      );
      if (minLength) validators.push(Validators.minLength(minLength.value));

      const maxLength = validationRules.find(
        (v: any) => v.type === 'maxLength',
      );
      if (maxLength) validators.push(Validators.maxLength(maxLength.value));

      const minValue = validationRules.find((v: any) => v.type === 'min');
      if (minValue) validators.push(Validators.min(minValue.value));

      const maxValue = validationRules.find((v: any) => v.type === 'max');
      if (maxValue) validators.push(Validators.max(maxValue.value));

      const regex = validationRules.find(
        (v: any) => v.type?.toLowerCase() === 'regex',
      );

      if (regex?.value && field.fieldType !== 'domainWithInputTags') {
        let pattern = regex.value.trim();
        pattern = pattern.replace(/^\/|\/$/g, '');
        pattern = pattern.replace(/\\\\/g, '\\');
        const regExp =
          field.fieldType === 'textarea'
            ? new RegExp('^(?:' + pattern + ')$', 's')
            : new RegExp('^(?:' + pattern + ')$');
        validators.push(Validators.pattern(regExp));
      }

      if (
        field.fieldType === 'email' ||
        validationRules.some((v: any) => v.type === 'email')
      ) {
        validators.push(Validators.email);
      }

      // Handle OTP fields
      if (field.fieldName === 'otp') {
        const otpLength = field.properties?.otpLength || 6;

        const otpControls = Array.from(
          { length: otpLength },
          () =>
            new FormControl('', [
              Validators.required,
              Validators.pattern('[0-9]'),
            ]),
        );

        group['otpArray'] = this.fb.array(otpControls);
        group['otp'] = new FormControl('');
      } else {
        const isAddMode =
          this.recordIDs === 'add' ||
          this.recordID === 'add' ||
          this.activeModalContext?.recordID === 'add';
        const existingValue = isAddMode
          ? null
          : this.saveForm?.get(field.fieldName)?.value;
        const taskValue = this.taskData?.[field.fieldName];

        let modalValue = null;
        const isBulkUpdate =
          this.activeModalContext?.bulkUpdate !== undefined &&
          this.activeModalContext?.bulkUpdate === true;
        if (isBulkUpdate) {
          if (field.fieldName === 'status') {
            modalValue = '';
          } else if (field.fieldName === 'risk') {
            modalValue = '';
          } else if (field.fieldName === 'priority') {
            modalValue = '';
          } else if (field.fieldName === 'startDate') {
            modalValue = '';
          } else if (field.fieldName === 'dueDate') {
            modalValue = '';
          } else if (field.fieldName === 'delay') {
            modalValue = 0;
          } else if (field.fieldName === 'assignee') {
            modalValue = '';
          }
        }
        if (this.isRiskFilterApply == true) {
          if (field.fieldName === 'status') {
            modalValue = this.activeModalContext?.risksStatus;
          } else if (field.fieldName === 'probability') {
            modalValue = this.activeModalContext?.riskProbability;
          } else if (field.fieldName === 'impact') {
            modalValue = this.activeModalContext?.riskImpact;
          } else if (field.fieldName === 'category') {
            modalValue = this.activeModalContext?.riskCategory;
          } else if (field.fieldName === 'domains') {
            modalValue = this.activeModalContext.riskDomains;
          } else if (field.fieldName === 'riskLevel') {
            modalValue = this.activeModalContext.riskLevel;
          } else if (field.fieldName === 'owners') {
            modalValue = this.activeModalContext.riskOwners;
          }
        }
        if (this.isFilterApply == true) {
          if (field.fieldName === 'status') {
            modalValue = this.activeModalContext?.taskStatus;
          } else if (field.fieldName === 'priority') {
            modalValue = this.activeModalContext?.taskPriority;
          } else if (field.fieldName === 'risk') {
            modalValue = this.activeModalContext?.riskStatus;
          } else if (field.fieldName === 'domainSubdomainMappings') {
            modalValue = this.activeModalContext?.domain;
          } else if (field.fieldName === 'assigned') {
            modalValue =
              this.activeModalContext?.assignedUser ??
              this.activeModalContext?.assigned;
          } else if (
            field.fieldName === 'mappedStandards_standardName' ||
            field.fieldName === 'mappedStandards.standardName'
          ) {
            modalValue = this.activeModalContext.standardName;
          } else if (field.fieldName === 'tags') {
            modalValue = this.activeModalContext?.tags;
          } else if (field.fieldName === 'technology') {
            modalValue =
              this.activeModalContext?.technology !== undefined
                ? this.activeModalContext.technology
                : null;
          } else if (field.fieldName === 'impact') {
            modalValue =
              this.activeModalContext?.impact ??
              this.activeModalContext?.taskImpact ??
              this.activeModalContext?.riskImpact;
          } else if (field.fieldName === 'probability') {
            modalValue =
              this.activeModalContext?.probability ??
              this.activeModalContext?.taskProbability ??
              this.activeModalContext?.riskProbability;
          } else {
            modalValue = this.activeModalContext?.[field.fieldName];
          }
        } else if (this.isFilterApply == false) {
          if (field.fieldName === 'status') {
            modalValue = this.activeModalContext.taskStatus;
          } else if (field.fieldName === 'risk') {
            modalValue = this.activeModalContext.riskStatus;
          } else if (field.fieldName === 'priority') {
            // modalValue = this.activeModalContext.taskPriority || 'Do Later';
            modalValue = this.activeModalContext.taskPriority;
          } else if (field.fieldName === 'startDate') {
            const iso = this.activeModalContext?.startDate;
            modalValue = iso ? new Date(iso).toISOString().split('T')[0] : '';
          } else if (field.fieldName === 'dueDate') {
            const dueDateIso = this.activeModalContext?.dueDate;
            modalValue = dueDateIso
              ? new Date(dueDateIso).toISOString().split('T')[0]
              : '';
          } else if (field.fieldName === 'delay') {
            modalValue = this.activeModalContext.delay;
          }
        }

        // if (
        //   this.activeModalContext?.showControl != null &&
        //   this.activeModalContext?.showLocation != '' &&
        //   this.isSecurityFilterApply == false
        // ) {
        //   if (field.fieldName === 'location') {
        //     modalValue = this.activeModalContext?.showLocation;
        //   } else if (field.fieldName === 'controls') {
        //     modalValue = this.activeModalContext.showControl;
        //   }
        // }

        if (this.isSecurityFilterApply == true) {
          if (field.fieldName === 'location') {
            modalValue = this.activeModalContext?.selectedLocation;
          } else if (field.fieldName === 'controls') {
            modalValue = this.activeModalContext?.selectedControls;
          }
        }
        if (this.activeModalContext && this.isHeader) {
          if (field.fieldName === 'fullName') {
            modalValue = this.activeModalContext?.fullName;
          } else if (field.fieldName === 'userEmail') {
            modalValue = this.activeModalContext?.userEmail;
          } else if (field.fieldName === 'mobileNumber') {
            modalValue = this.activeModalContext?.mobileNumber;
          } else if (field.fieldName === 'alternateMobile') {
            modalValue = this.activeModalContext?.alternateMobile;
          }
        }
        if (this.actionableStatusEdit) {
          if (field.fieldName === 'status') {
            modalValue = this.activeModalContext?.actionableStatus;
          }
        }
        if (this.isActionableFilterApply) {
          if (field.fieldName == 'status') {
            modalValue =
              this.activeModalContext?.actionableStatus ??
              this.activeModalContext?.status;
          } else if (field.fieldName == 'assigned') {
            modalValue =
              this.activeModalContext?.assigned ??
              this.activeModalContext?.assignedUser;
          } else if (this.activeModalContext?.[field.fieldName] !== undefined) {
            modalValue = this.activeModalContext[field.fieldName];
          } else if (
            field.fieldName === 'risk' &&
            this.activeModalContext?.riskStatus !== undefined
          ) {
            modalValue = this.activeModalContext.riskStatus;
          } else if (
            field.fieldName === 'riskStatus' &&
            this.activeModalContext?.risk !== undefined
          ) {
            modalValue = this.activeModalContext.risk;
          } else if (
            field.fieldName === 'impact' &&
            this.activeModalContext?.riskImpact !== undefined
          ) {
            modalValue = this.activeModalContext.riskImpact;
          } else if (
            field.fieldName === 'assetType' &&
            this.activeModalContext?.asset_type !== undefined
          ) {
            modalValue = this.activeModalContext.asset_type;
          } else if (
            field.fieldName === 'asset_type' &&
            this.activeModalContext?.assetType !== undefined
          ) {
            modalValue = this.activeModalContext.assetType;
          }
        }
        // ✅ ADD THIS
        if (
          field.fieldType == 'search' &&
          field.fieldName === 'assigned' &&
          this.activeModalContext?.assigned
        ) {
          modalValue = this.activeModalContext.assigned;
        }

        if (field.fieldName === 'role') {
          const isAddMode =
            this.recordIDs === 'add' ||
            this.recordID === 'add' ||
            this.activeModalContext?.recordID === 'add';
          const roleObjVal =
            this.initialRoleFromResponse ||
            (field.value && typeof field.value === 'object'
              ? Array.isArray(field.value)
                ? field.value[0]
                : field.value
              : null);
          modalValue = isAddMode
            ? null
            : roleObjVal ||
              this.getSelectedRoleValue() ||
              field.value ||
              field.defaultValue ||
              null;
        }

        const hasValue = (v: any) =>
          v !== null &&
          v !== undefined &&
          (typeof v === 'string' ? v.trim() !== '' : true);

        let defaultValue: any = null;
        if (isAddMode) {
          if (field.fieldName === 'role') {
            defaultValue = null;
          } else if (hasValue(modalValue)) {
            defaultValue = modalValue;
          } else if (hasValue(field.defaultValue)) {
            defaultValue = field.defaultValue;
          } else {
            defaultValue = field.fieldName === 'technology' ? null : '';
          }
        } else {
          if (hasValue(modalValue)) {
            defaultValue = modalValue;
          } else if (hasValue(taskValue)) {
            defaultValue = taskValue;
          } else if (hasValue(field.value)) {
            defaultValue = field.value;
          } else if (hasValue(field.defaultValue)) {
            defaultValue = field.defaultValue;
          } else if (hasValue(existingValue)) {
            defaultValue = existingValue;
          } else {
            defaultValue =
              field.fieldName === 'technology' || field.fieldName === 'role'
                ? null
                : '';
          }
          if (field.fieldName === 'role' && !hasValue(defaultValue)) {
            defaultValue = null;
          }
        }

        if (
          isTargetIntegrationForm &&
          typeof defaultValue === 'string' &&
          (defaultValue.includes('{{integrationProfileRecordId}}') ||
            defaultValue.includes('{{integrationProfileRecordID}}'))
        ) {
          defaultValue = defaultValue
            .replace(/\{\{integrationProfileRecordId\}\}/g, '6a630b2a0e3b3a9926943534')
            .replace(/\{\{integrationProfileRecordID\}\}/g, '6a630b2a0e3b3a9926943534');
        }

        if (field.fieldType === 'date' && defaultValue) {
          defaultValue = this.formatDate(defaultValue);
        }

        if (field.fieldName.includes('.')) {
          // Flatten standard dots to keep FormGroup flat or register control
          group[field.fieldName] = new FormControl(defaultValue, validators);
        } else {
          group[field.fieldName] = new FormControl(defaultValue, validators);
        }
      }
    });

    // Create FormGroup
    this.saveForm = new FormGroup(group);
    this.registerCustomFieldDependencyWatchers();
    this.visibleFields['noDataField'] = true;
    this.formReady.emit();

    // Patch taskData safely without marking dirty
    Object.keys(this.taskData || {}).forEach((key) => {
      if (this.saveForm.contains(key)) {
        if (key === 'comment' && !this.taskData[key]) return;
        if (key === 'searchUser' && this.activeModalContext?.assigned) return;
        // Don't let raw taskData overwrite already-formatted dueDate/startDate from activeModalContext
        if (key === 'dueDate' && this.activeModalContext?.dueDate) return;
        if (key === 'startDate' && this.activeModalContext?.startDate) return;
        this.saveForm.get(key)?.setValue(this.taskData[key]);
      }
    });
    if (this.subItemData) {
      Object.entries(this.subItemData).forEach(([key, value]) => {
        if (!this.saveForm.contains(key)) return;

        let finalValue = value;

        // 🔥 Convert date fields automatically
        const control = this.saveForm.get(key);
        const fieldConfig = this.formFields.find(
          (f: any) => f.fieldName === key,
        );

        if (fieldConfig?.fieldType === 'date' && typeof value === 'string') {
          finalValue = this.convertToDateInputFormat(value);
        }

        control?.setValue(finalValue, { emitEvent: false });
      });
    }

    const commentControl = this.saveForm.get('comment');
    if (commentControl) {
      const baseValidator = commentControl.validator || null;

      const setCommentRequired = (required: boolean) => {
        const list = [];
        if (baseValidator) list.push(baseValidator);
        if (required) list.push(Validators.required);
        commentControl.setValidators(Validators.compose(list));
        commentControl.updateValueAndValidity({ emitEvent: false });
      };

      const triggerFields = [
        'status',
        'risk',
        'priority',
        'startDate',
        'dueDate',
        'delay',
        'assignee',
      ];

      // Track if the user has actually changed a trigger field
      let userChangedTrigger = false;
      this.formRebuild$.next(); // kills previous form subscriptions

      triggerFields.forEach((name) => {
        const c = this.saveForm.get(name);
        if (c) {
          c.valueChanges.pipe(takeUntil(this.formRebuild$)).subscribe(() => {
            userChangedTrigger = true;

            const anyTriggerHasValue = triggerFields.some((fieldName) => {
              const v = this.saveForm.get(fieldName)?.value;
              return v !== null && v !== undefined && String(v).trim() !== '';
            });

            const shouldRequire = userChangedTrigger && anyTriggerHasValue;
            setCommentRequired(shouldRequire);
            // Sync the asterisk indicator on the label
            this.commentRequired = shouldRequire;
          });
        }
      });

      setCommentRequired(false);
      this.commentRequired = false;
    }

    // Dynamically replace {{BASE}} and <HOST_IP> in dependent fields
    const baseControlCandidates = [
      'config.baseURL',
      'config.baseUrl',
      'baseURL',
      'baseUrl',
      'config.baseAPIPath',
      'baseAPIPath',
    ];
    const activeBaseFieldName = baseControlCandidates.find(
      (name) => !!this.saveForm.get(name),
    );
    const baseControl = activeBaseFieldName
      ? this.saveForm.get(activeBaseFieldName)
      : null;
    if (baseControl) {
      baseControl.valueChanges
        .pipe(takeUntil(this.formRebuild$))
        .subscribe((val) => {
          if (val && typeof val === 'string') {
            const trimmedBase = val.trim();
            let hostIp = '';
            try {
              let cleanUrl = trimmedBase;
              if (!/^https?:\/\//i.test(cleanUrl)) {
                cleanUrl = 'http://' + cleanUrl;
              }
              hostIp = new URL(cleanUrl).hostname;
            } catch (e) {
              let fallback = trimmedBase.replace(/^https?:\/\//i, '');
              hostIp = fallback.split('/')[0].split(':')[0].trim();
            }

            const cleanBase = trimmedBase.replace(/\/+$/, '');

            this.formFields?.forEach((field: any) => {
              const fieldNameLower = field.fieldName?.toLowerCase() || '';
              if (
                field.fieldName !== activeBaseFieldName &&
                fieldNameLower !== 'config.refreshtokenurl' &&
                fieldNameLower !== 'refreshtokenurl'
              ) {
                const rawVal =
                  this.saveForm.get(field.fieldName)?.value ||
                  field.defaultValue ||
                  field.value ||
                  '';
                const defaultValue =
                  typeof rawVal === 'string'
                    ? rawVal
                    : field.defaultValue || field.value || '';
                if (typeof defaultValue === 'string') {
                  let updatedValue = defaultValue;
                  if (updatedValue.includes('{{BASE}}')) {
                    updatedValue = updatedValue.replace(
                      /\{\{BASE\}\}/g,
                      cleanBase,
                    );
                  }
                  if (updatedValue.includes('{{baseUrl}}')) {
                    updatedValue = updatedValue.replace(
                      /\{\{baseUrl\}\}/g,
                      cleanBase,
                    );
                  }
                  if (updatedValue.includes('{{baseURL}}')) {
                    updatedValue = updatedValue.replace(
                      /\{\{baseURL\}\}/g,
                      cleanBase,
                    );
                  }
                  if (updatedValue.includes('{{baseAPIPath}}')) {
                    updatedValue = updatedValue.replace(
                      /\{\{baseAPIPath\}\}/g,
                      cleanBase,
                    );
                  }
                  if (updatedValue.includes('<HOST_IP>')) {
                    updatedValue = updatedValue.replace(/<HOST_IP>/g, hostIp);
                  }
                  if (
                    /^https?:\/\//i.test(updatedValue) &&
                    !updatedValue.startsWith(cleanBase) &&
                    !updatedValue.startsWith(trimmedBase)
                  ) {
                    updatedValue = updatedValue.replace(
                      /^https?:\/\/[^\/?#]+/i,
                      cleanBase,
                    );
                  }
                  // Clean up duplicate ports like :8484:8484
                  updatedValue = updatedValue.replace(/:(\d+)(:\1)+/g, ':$1');
                  // Normalize any duplicate slashes in the path (excluding protocol)
                  updatedValue = updatedValue.replace(/([^:])\/{2,}/g, '$1/');

                  if (
                    updatedValue !== this.saveForm.get(field.fieldName)?.value
                  ) {
                    this.saveForm
                      .get(field.fieldName)
                      ?.setValue(updatedValue, { emitEvent: false });
                  }
                }
              }
            });
          }
        });
      // Trigger initial update if it already has a value
      const initialVal = baseControl.value;
      if (initialVal) {
        baseControl.setValue(initialVal, { emitEvent: true });
      }
    }

    // Reset pristine after patching
    this.saveForm.markAsPristine();
    this.saveForm.markAsUntouched();

    if (this.disableFields === true || this.disableFields === 'true') {
      this.saveForm.disable();
    }

    const hasViewCard = this.formFields?.some(
      (field: any) => field.componentId === 'viewCard',
    );

    const hasResourcesCard = this.formFields?.some(
      (field: any) => field.componentId === 'resourcesCard',
    );

    // Initial state
    this.isDisabled =
      hasViewCard || hasResourcesCard ? false : this.saveForm.invalid;

    // Subscription
    this.saveForm.valueChanges.subscribe(() => {
      if (hasViewCard || hasResourcesCard) {
        this.isDisabled = false;
      } else {
        this.isDisabled = this.saveForm.invalid;
      }
    });
  }

  private convertToDateInputFormat(value: string): string {
    if (!value) return '';

    if (value.includes(' ')) {
      return value.split(' ')[0];
    }

    return value;
  }

  updateIsDisabled(): void {
    const isFormBlank = this.isFormEmpty(this.saveForm);
    const isFormUnchanged = this.isFormUnchanged(this.saveForm);
    const isInvalid = this.saveForm.invalid;
    this.isDisabled = isFormBlank || isFormUnchanged || isInvalid;
  }

  isFormUnchanged(form: FormGroup): boolean {
    if (!this.initialFormValue) return false;

    return this.deepEqual(this.initialFormValue, form.getRawValue());
  }

  isFormEmpty(control: AbstractControl): boolean {
    if (control instanceof FormControl) {
      return this.isValueEmpty(control.value);
    }

    if (control instanceof FormArray) {
      if (control.length === 0) return true;

      return control.controls.every((ctrl) => this.isFormEmpty(ctrl));
    }

    if (control instanceof FormGroup) {
      return Object.values(control.controls).every((ctrl) =>
        this.isFormEmpty(ctrl),
      );
    }

    return true;
  }

  private isValueEmpty(value: any): boolean {
    if (value === null || value === undefined) return true;

    if (typeof value === 'string') {
      return value.trim() === '';
    }

    if (Array.isArray(value)) {
      return value.length === 0;
    }

    if (typeof value === 'object') {
      return Object.keys(value).length === 0;
    }

    return false;
  }

  private deepEqual(a: any, b: any): boolean {
    if (a === b) return true;

    if (a == null || b == null) return false;

    if (typeof a !== typeof b) return false;

    // Handle Arrays
    if (Array.isArray(a) && Array.isArray(b)) {
      if (a.length !== b.length) return false;

      for (let i = 0; i < a.length; i++) {
        if (!this.deepEqual(a[i], b[i])) {
          return false;
        }
      }
      return true;
    }

    // Handle Objects
    if (typeof a === 'object') {
      const keysA = Object.keys(a);
      const keysB = Object.keys(b);

      if (keysA.length !== keysB.length) return false;

      for (const key of keysA) {
        if (!this.deepEqual(a[key], b[key])) {
          return false;
        }
      }
      return true;
    }

    return false;
  }

  @ViewChild(UserInviteComponent)
  userInviteComponent!: UserInviteComponent;

  /**
   * Extracts and returns the YYYY-MM-DD date part from a date-time string or Date object.
   */
  extractDatePart(value: any): string | null {
    if (!value) return null;
    if (value instanceof Date) {
      return value.toISOString().split('T')[0];
    }
    if (typeof value !== 'string') return null;
    const trimmed = value.trim();
    if (trimmed.includes('T')) {
      return trimmed.split('T')[0];
    }
    if (trimmed.includes(' ')) {
      return trimmed.split(' ')[0];
    }
    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
      return trimmed;
    }
    return null;
  }

  /**
   * Extracts and returns the date part from a date-time string.
   */
  formatDate(value: any) {
    if (!value) return value;
    if (typeof value === 'string' && value.includes(' ')) {
      return value.split(' ')[0];
    }
    return value;
  }

  /**
   * Capitalizes the first letter of each word in a string.
   */
  capitalizeWords(value: string): string {
    if (!value) return value;
    return value
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  /**
   * Handles form submission, validation, and all related actions
   * (save, update, assign, filter, workflow, modal actions).
   */
  onSave(btn?: any): void {
    if (!this.saveForm) return;
    if (this.hasDomainError) {
      return;
    }

    if (this.hasComponent('userInvite') && btn?.componentId === 'nextButton') {
      this.userInviteComponent.submitInvitation();
      return;
    }

    if (!btn || btn.clickAction === '__submit__') {
    }
    // --- Helper utilities ---------------------------------------------------
    const emitCloseAndReset = (resetForm = false) => {
      this.closeModal.emit();
      if (resetForm) this.saveForm.reset();
    };

    const submitPayload = (
      payload: any,
      originalData?: any,
      skipWorkflowSave?: boolean,
      operationType?: any,
    ) => {
      this.submitFormViaApi(
        payload,
        originalData,
        skipWorkflowSave,
        operationType,
      );
    };

    const isOneOf = (val: string | undefined, list: string[]) =>
      !!val && list.includes(val);

    // --- Early exits for modal-level actions --------------------------------
    const modalActions = ['clearAll'];
    if (isOneOf(btn?.clickAction, modalActions)) {
      if (btn?.clickAction === 'clearAll') {
        const formId = this.activeModalContext?.formId;
        if (this.isActionableFilterApply) {
          this.clearActionableAll.emit({ formId, options: { limit: 5 } });
          if (this.saveForm) {
            this.saveForm.reset();
          }
        } else {
          this.clearAll.emit({ formId, options: { limit: 12, sort: '_id' } });
          this.saveForm.reset();
        }
      }
      this.closeModal.emit();
      return;
    }

    const modalAction = ['modalClose'];
    if (isOneOf(btn?.clickAction, modalAction)) {
      const useAPI = this.formData?.apiIntegration?.useAPI;

      // Case 1: API integration disabled → Just close modal
      if (useAPI === false) {
        emitCloseAndReset(true);
        return;
      }
      if (
        btn.componentId == 'cancelButton' ||
        btn.componentId == 'previousButton'
      ) {
        emitCloseAndReset(true);
        return;
      }
    }

    // --- Previous navigation ------------------------------------------------
    if (isOneOf(btn?.componentId, ['previousButton'])) {
      this.clickedOnPrevious.emit();
      return;
    }

    // --- Explicit navigation (close/modal) ---------------------------------
    if (isOneOf(btn?.clickAction, ['closeModal'])) {
      emitCloseAndReset(true);
      return;
    }

    // --- Retry / re-run workflow --------------------------------------------
    if (isOneOf(btn?.fieldType, ['retryButton'])) {
      if (this.formData?.sseConfig?.integration?.authUrl) {
        this.navigateOAuth(this.formData.sseConfig, this.nodeId);
        setTimeout(() => this.saveWorkflow(true), 200);
      } else {
        setTimeout(() => this.saveWorkflow(true), 200);
      }
      return;
    }

    // --- Validate form -----------------------------------------------------
    this.saveForm?.markAllAsTouched();
    const isCustomValid = this.validateCustomComponents();
    if (!isCustomValid || !this.saveForm?.valid) {
      return;
    }
    // --- Clean form --------------------------------------------------------
    let cleanedFormData = this.filterFormValue(this.saveForm, [
      'otpArray',
      'otpHeader',
    ]);

    if (cleanedFormData['mappedStandards_standardName'] !== undefined) {
      cleanedFormData['mappedStandards.standardName'] =
        cleanedFormData['mappedStandards_standardName'];
      delete cleanedFormData['mappedStandards_standardName'];
    }

    this.formFields?.forEach((field: any) => {
      if (
        (field.fieldType === 'switch' && field.componentId == 'switchField') ||
        field.componentId === 'switchStatus'
      ) {
        const key = field.fieldName;
        const value = cleanedFormData[key];

        if (value !== undefined) {
          // ✅ If already string → keep it
          if (value === 'Active' || value === 'Inactive') {
            cleanedFormData[key] = value;
          }
          // ✅ If boolean → convert
          else {
            cleanedFormData[key] = value ? 'Active' : 'Inactive';
          }
        }
      }
    });
    // --- Trim trailing whitespace from all string fields --------------------
    Object.keys(cleanedFormData).forEach((key) => {
      const value = cleanedFormData[key];

      if (typeof value === 'string') {
        cleanedFormData[key] = value.trimEnd();
      }

      if (Array.isArray(value)) {
        cleanedFormData[key] = value.map((v) =>
          typeof v === 'string' ? v.trimEnd() : v,
        );
      }
    });

    // --- Convert domain fields to lowercase ---------------------------------
    this.formFields?.forEach((field: any) => {
      if (field.componentId == 'domainInput') {
        const key = field.fieldName;
        const value = cleanedFormData[key];

        if (typeof value === 'string') {
          cleanedFormData[key] = value.toLowerCase();
        }

        if (Array.isArray(value)) {
          cleanedFormData[key] = value.map((v: string) =>
            typeof v === 'string' ? v.toLowerCase() : v,
          );
        }
      }
    });

    // --- Convert date fields (fieldType === 'date'): preserve original ISO if unchanged, else format with current time ---
    this.formFields?.forEach((field: any) => {
      if (field.fieldType === 'date') {
        const key = field.fieldName;
        const value = cleanedFormData[key];
        if (
          typeof value === 'string' &&
          /^\d{4}-\d{2}-\d{2}$/.test(value.trim())
        ) {
          let originalValue =
            this.activeModalContext?.[key] ??
            this.taskData?.[key] ??
            this.subItemData?.[key] ??
            (typeof this.record === 'object' ? this.record?.[key] : null);

          if (originalValue instanceof Date) {
            originalValue = originalValue.toISOString();
          }

          const originalDatePart = this.extractDatePart(originalValue);
          if (
            originalValue &&
            originalDatePart &&
            value.trim() === originalDatePart
          ) {
            cleanedFormData[key] = originalValue;
          } else {
            const timePart = new Date().toISOString().split('T')[1];
            cleanedFormData[key] = `${value.trim()}T${timePart}`;
          }
        }
      }
    });

    // --- Override fields.value with fields.defaultValue when both exist ----
    this.formFields?.forEach((field: any) => {
      if (
        field?.fieldName &&
        field?.fieldName !== 'role' &&
        field?.fieldName !== 'roles' &&
        cleanedFormData[field.fieldName] !== undefined &&
        field?.defaultValue !== undefined &&
        field?.defaultValue !== null &&
        field?.defaultValue !== ''
      ) {
        cleanedFormData[field.fieldName] = field.defaultValue;
      }
    });

    const isTargetIntegrationFormOnSave =
      this.nodeId === '6a6310c80e3b3a9926943566' ||
      this.formData?.formFields?.[0]?.formId === '6a6310c80e3b3a9926943566' ||
      this.activeModalContext?.formId === '6a6310c80e3b3a9926943566' ||
      this.formFields?.some((f: any) => f.formId === '6a6310c80e3b3a9926943566');

    if (isTargetIntegrationFormOnSave) {
      this.formFields?.forEach((field: any) => {
        if (
          field?.fieldName &&
          typeof field.defaultValue === 'string' &&
          (field.defaultValue === '{{integrationProfileRecordId}}' ||
            field.defaultValue.includes('{{integrationProfileRecordId}}'))
        ) {
          field.defaultValue = field.defaultValue.replace(
            /\{\{integrationProfileRecordId\}\}/g,
            '6a630b2a0e3b3a9926943534',
          );
          cleanedFormData[field.fieldName] = field.defaultValue;
        }
      });
      Object.keys(cleanedFormData).forEach((key) => {
        if (
          typeof cleanedFormData[key] === 'string' &&
          cleanedFormData[key].includes('{{integrationProfileRecordId}}')
        ) {
          cleanedFormData[key] = cleanedFormData[key].replace(
            /\{\{integrationProfileRecordId\}\}/g,
            '6a630b2a0e3b3a9926943534',
          );
        }
      });
    }

    // --- Replace {{BASE}} and <HOST_IP> in cleanedFormData fields ---
    const getBaseUrlFromAny = (obj: any): string => {
      if (!obj || typeof obj !== 'object') return '';
      if (typeof obj['config.baseURL'] === 'string' && obj['config.baseURL'])
        return obj['config.baseURL'];
      if (typeof obj['config.baseUrl'] === 'string' && obj['config.baseUrl'])
        return obj['config.baseUrl'];
      if (
        typeof obj['config.baseAPIPath'] === 'string' &&
        obj['config.baseAPIPath']
      )
        return obj['config.baseAPIPath'];
      if (typeof obj['baseURL'] === 'string' && obj['baseURL'])
        return obj['baseURL'];
      if (typeof obj['baseUrl'] === 'string' && obj['baseUrl'])
        return obj['baseUrl'];
      if (typeof obj['baseAPIPath'] === 'string' && obj['baseAPIPath'])
        return obj['baseAPIPath'];
      if (obj['config'] && typeof obj['config'] === 'object') {
        const cfg = obj['config'];
        if (typeof cfg['baseURL'] === 'string' && cfg['baseURL'])
          return cfg['baseURL'];
        if (typeof cfg['baseUrl'] === 'string' && cfg['baseUrl'])
          return cfg['baseUrl'];
        if (typeof cfg['baseAPIPath'] === 'string' && cfg['baseAPIPath'])
          return cfg['baseAPIPath'];
      }
      return '';
    };

    const baseAPIPath =
      getBaseUrlFromAny(cleanedFormData) ||
      getBaseUrlFromAny(this.saveForm?.getRawValue()) ||
      getBaseUrlFromAny(this.taskData) ||
      getBaseUrlFromAny(this.activeModalContext);

    if (baseAPIPath && typeof baseAPIPath === 'string') {
      const trimmedBase = baseAPIPath.trim();
      let hostIp = '';
      try {
        let cleanUrl = trimmedBase;
        if (!/^https?:\/\//i.test(cleanUrl)) {
          cleanUrl = 'http://' + cleanUrl;
        }
        hostIp = new URL(cleanUrl).hostname;
      } catch (e) {
        let fallback = trimmedBase.replace(/^https?:\/\//i, '');
        hostIp = fallback.split('/')[0].split(':')[0].trim();
      }

      const cleanBase = trimmedBase.replace(/\/+$/, '');

      const replaceInValue = (val: any): any => {
        if (typeof val === 'string') {
          let updatedValue = val;
          if (updatedValue.includes('{{BASE}}')) {
            updatedValue = updatedValue.replace(/\{\{BASE\}\}/g, cleanBase);
          }
          if (updatedValue.includes('{{baseUrl}}')) {
            updatedValue = updatedValue.replace(/\{\{baseUrl\}\}/g, cleanBase);
          }
          if (updatedValue.includes('{{baseURL}}')) {
            updatedValue = updatedValue.replace(/\{\{baseURL\}\}/g, cleanBase);
          }
          if (updatedValue.includes('{{baseAPIPath}}')) {
            updatedValue = updatedValue.replace(
              /\{\{baseAPIPath\}\}/g,
              cleanBase,
            );
          }
          if (updatedValue.includes('<HOST_IP>')) {
            updatedValue = updatedValue.replace(/<HOST_IP>/g, hostIp);
          }
          if (
            /^https?:\/\//i.test(updatedValue) &&
            !updatedValue.startsWith(cleanBase) &&
            !updatedValue.startsWith(trimmedBase)
          ) {
            updatedValue = updatedValue.replace(
              /^https?:\/\/[^\/?#]+/i,
              cleanBase,
            );
          }
          // Clean up duplicate ports like :8484:8484
          updatedValue = updatedValue.replace(/:(\d+)(:\1)+/g, ':$1');
          // Normalize any duplicate slashes in the path (excluding protocol)
          updatedValue = updatedValue.replace(/([^:])\/{2,}/g, '$1/');

          return updatedValue;
        }
        if (Array.isArray(val)) {
          return val.map((item) => replaceInValue(item));
        }
        if (typeof val === 'object' && val !== null) {
          Object.keys(val).forEach((k) => {
            const kLower = k.toLowerCase();
            if (
              kLower !== 'config.refreshtokenurl' &&
              kLower !== 'refreshtokenurl'
            ) {
              val[k] = replaceInValue(val[k]);
            }
          });
          return val;
        }
        return val;
      };

      cleanedFormData = replaceInValue(cleanedFormData);
    }

    // If UI-only components exist that mean "no submit" to saveWorkflow
    const skipSubmitField = this.formFields.find(
      (f: any) =>
        f.componentId === 'noDataTypeOne' ||
        f.componentId == 'resourcesCard' ||
        f.componentId === 'dataViewWithLoader',
    );
    if (
      skipSubmitField &&
      this.formData?.apiIntegration?.useAPI == false &&
      btn?.fieldType != 'disconnectButton'
    ) {
      this.saveWorkflow();
      return;
    }

    // --- Field lookups used in many branches --------------------------------
    const domainField = this.formFields.find(
      (f: any) => f.fieldType === 'domainWithInputTags',
    );
    const domainFieldName = domainField?.fieldName;
    const inputSearchField = this.formFields.find(
      (f: any) =>
        f.componentId === 'inputSearchField' ||
        (f.componentId === 'dropdownWithSearch' && f.fieldName === 'assignee'),
    );
    const startDateField = this.formFields.find(
      (f: any) => f.fieldName === 'startDate',
    );
    const fieldNameForAssign = inputSearchField?.fieldName;
    const selectedUser = fieldNameForAssign
      ? cleanedFormData?.[fieldNameForAssign]
      : undefined;
    const parentTaskID = this.activeModalContext?.parentTaskID;

    // --- Assign user to the task -----------------------
    if (
      inputSearchField &&
      parentTaskID == undefined &&
      !this.activeModalContext?.bulkUpdate
    ) {
      const payload = {
        formId: FORM_ID.TASK_LIST,
        recordId: this.taskId,
        data: {
          assigned: selectedUser.email,
          assignee: selectedUser,
          parent: '',
        },
      };
      submitPayload(payload, cleanedFormData);
      return;
    }

    //  For actionable assign with parent taskID
    if (
      inputSearchField &&
      parentTaskID !== undefined &&
      !this.activeModalContext?.bulkUpdate
    ) {
      const payload: any = {
        formId: FORM_ID.ACTIONABLE_LIST,
        recordId: this.taskId,
        data: {
          assigned: selectedUser.email,
          assignee: selectedUser,
          parent: parentTaskID,
          issue_key: this.activeModalContext?.issue_key,
        },
      };

      // Add linkedTaskID only when present and non-empty
      if (this.activeModalContext?.linkedId) {
        payload.data.linkedTaskID = this.activeModalContext.linkedId;
      }

      submitPayload(payload, cleanedFormData);
      return;
    }

    // --- Actionable status edit ------------------------------------------------
    if (this.actionableStatusEdit === true) {
      const payload = {
        formId: this.activeModalContext?.nodeId,
        recordId: this.activeModalContext?.record,
        data: {
          ...cleanedFormData,
          issue_key: this.activeModalContext?.linkedId,
        },
      };
      submitPayload(payload, cleanedFormData);
      return;
    }

    // --- startDate + record update path --------------------------------------
    if (startDateField && this.record) {
      const payload = {
        formId: this.formData?.formFields?.[0]?.formId,
        recordId: this.record,
        data: {
          ...cleanedFormData,
          issue_key: this.activeModalContext?.linkedTaskID,
        },
      };
      submitPayload(payload, cleanedFormData);
      return;
    }

    // --- domainWithInputTags: create one request per domain entry -------------
    const domainList =
      this.domainTagsForSubmit.length > 0
        ? this.domainTagsForSubmit
        : cleanedFormData[domainFieldName];

    if (Array.isArray(domainList) && domainList.length > 0) {
      const accessToken = this.auth.token;

      domainList.forEach((domain: string) => {
        const normalizedDomain = domain.trim().toLowerCase();

        const filteredData = { ...cleanedFormData };
        delete filteredData['nameTags'];

        let domainName = normalizedDomain;
        let port: string | undefined;

        // ✅ Check if domain contains port (e.g., example.com:8080)
        if (normalizedDomain.includes(':')) {
          const parts = normalizedDomain.split(':');
          domainName = parts[0];
          port = parts[1];
        }

        const singleFormPayload = {
          formId: this.formData?.formFields?.[0]?.formId,
          data: {
            ...filteredData,
            name: domainName,
            at: accessToken,
            ...(port && { port }), // ✅ only add port if present
          },
        };

        submitPayload(singleFormPayload, cleanedFormData);
      });

      return;
    }

    // --- Special collection path: primaryIAMSourceSelection -------------------
    if (
      this.formData?.formCollection?.fieldCollectionData ===
      'primaryIAMSourceSelection'
    ) {
      const filteredData = { ...cleanedFormData };
      delete filteredData['nameTags'];
      const accessToken = this.auth.token;
      this.formPayload = {
        formId: this.formData?.formFields?.[0]?.formId,
        data: {
          ...filteredData,
          at: accessToken,
        },
      };
      submitPayload(this.formPayload, cleanedFormData);
      return;
    }

    // --- Default create/update path (when not filters / actionable edits) ----
    if (
      !this.isRiskFilterApply &&
      !this.isFilterApply &&
      !this.isSecurityFilterApply &&
      !this.actionableStatusEdit &&
      !this.isActionableFilterApply &&
      !this.recordIDs &&
      !this.activeModalContext?.bulkUpdate &&
      !this.activeModalContext?.reassignUpdate
    ) {
      const firstCollection = this.formData?.formCollection;
      const fieldData = firstCollection?.fieldCollectionData
        ?.trim()
        ?.toLowerCase();
      const fieldName = firstCollection?.fieldCollectionName
        ?.trim()
        ?.toLowerCase();
      const isResource = fieldData === 'resources' || fieldName === 'resources';
      const isJiraConfig =
        fieldData === 'jiraconfigs' || fieldName === 'jiraconfigs';
      this.formPayload = {
        formId: isResource
          ? FORM_ID.JIRA_CONFIGS
          : this.formData?.formFields?.[0]?.formId,
        data: cleanedFormData,
        ...(isResource || isJiraConfig ? { recordId: 'allUpdate' } : {}),
      };
      if (
        this.formPayload.formId === '6a143253ca440a759a89f9ff' ||
        this.formPayload.formId === FORM_ID.ADD_USER ||
        this.nodeId === '6a143253ca440a759a89f9ff' ||
        this.nodeId === FORM_ID.ADD_USER
      ) {
        // this.formPayload.formId = FORM_ID.USERS;
        this.formPayload.data = {
          ...this.formPayload.data,
          contactType: 'Others',
          userType: 'Member',
          source: 'Admin',
        };
        delete this.formPayload.data.formId;
        delete this.formPayload.data.formID;
        delete this.formPayload.data['role.role'];
        if (Array.isArray(this.formPayload.data.role)) {
          this.formPayload.data.role =
            this.formPayload.data.role.length > 0
              ? this.formPayload.data.role[0]
              : null;
        }
        if (
          this.formPayload.data.department &&
          !Array.isArray(this.formPayload.data.department)
        ) {
          this.formPayload.data.department = [this.formPayload.data.department];
        }
      }
      if (btn?.fieldType === 'disconnectButton') {
        this.skipWorkflowSave = true;
      }
      if (this.skipWorkflowSave) {
        submitPayload(this.formPayload, cleanedFormData, this.skipWorkflowSave);
      } else {
        submitPayload(this.formPayload, cleanedFormData);
      }
    }

    // --- Filter application flows (emit and close) ---------------------------
    const cleanFilterOptions = (options: any) => {
      const cleaned: any = {};
      Object.entries(options || {}).forEach(([key, value]) => {
        if (
          key === 'technology' &&
          (value === 'all' || value === null || value === undefined)
        ) {
          return;
        }
        const isEmpty =
          value === null ||
          value === undefined ||
          (value === '' && key !== 'technology') ||
          (Array.isArray(value) && value.length === 0) ||
          (typeof value === 'object' &&
            !Array.isArray(value) &&
            Object.keys(value as object).length === 0);
        if (!isEmpty) {
          cleaned[key] = value;
        }
      });
      return cleaned;
    };

    if (
      this.isFilterApply &&
      !this.isSecurityFilterApply &&
      !this.isRiskFilterApply &&
      !this.isActionableFilterApply &&
      !this.recordIDs &&
      !this.activeModalContext?.bulkUpdate &&
      !this.activeModalContext?.reassignUpdate
    ) {
      const formId = this.activeModalContext?.formId;
      this.onFilterApplied.emit({
        formId,
        options: cleanFilterOptions(cleanedFormData),
      });
      this.closeModal.emit();
      return;
    }
    if (
      !this.isFilterApply &&
      this.isRiskFilterApply &&
      !this.isSecurityFilterApply &&
      !this.isActionableFilterApply &&
      !this.recordIDs &&
      !this.activeModalContext?.bulkUpdate &&
      !this.activeModalContext?.reassignUpdate
    ) {
      const formId = this.activeModalContext?.formId;
      this.onFilterApplied.emit({
        formId,
        options: cleanFilterOptions(cleanedFormData),
      });
      this.closeModal.emit();
      return;
    }
    if (this.isSecurityFilterApply && !this.isFilterApply) {
      const formId = this.activeModalContext?.formId;
      this.onFilterApplied.emit({
        formId,
        options: cleanFilterOptions(cleanedFormData),
      });
      this.closeModal.emit();
      return;
    }

    if (this.isActionableFilterApply && !this.isFilterApply) {
      const formId = this.activeModalContext?.formId;
      this.onActionableFilterApplied.emit({
        formId,
        options: cleanFilterOptions(cleanedFormData),
      });
      this.closeModal.emit();
      return;
    }
    // ---------------- BulkUpdate ------------------------------
    if (this.activeModalContext?.bulkUpdate == true) {
      const dropdownWithSearch = this.formFields.find(
        (f: any) => f.componentId === 'dropdownWithSearch',
      );
      const fieldNameForAssign = dropdownWithSearch?.fieldName;
      const selectedUser = fieldNameForAssign
        ? cleanedFormData?.[fieldNameForAssign]
        : undefined;
      // Use the outer `selectedUser` which was mapped via fieldNameForAssign, or fallback to assignee
      const bulkSelectedUser = selectedUser || cleanedFormData?.assignee;
      const selectedTasks = this.activeModalContext.selectedTasks || [];
      const formData = cleanedFormData || {};
      // 🔎 Check if assignee changed (only if assignee is selected)
      const hasAssigneeChanged = bulkSelectedUser
        ? selectedTasks.some(
            (task: any) =>
              task?.assignee && task?.assignee?._id !== bulkSelectedUser?._id,
          )
        : false;
      // ✅ CASE 1: Assignee selected AND changed → open review
      if (bulkSelectedUser && hasAssigneeChanged) {
        const alreadyAssignedTasks = selectedTasks
          .filter(
            (task: any) =>
              task?.assignee && task.assignee._id !== bulkSelectedUser?._id,
          )
          .map((task: any) => ({
            ...task,
            previousAssignee: {
              _id: task.assignee._id,
              name: task.assignee.name,
              email: task.assignee.email,
              profilePhoto: task.assignee.profilePhoto,
            },
            currentAssignee: {
              _id: bulkSelectedUser._id,
              name: bulkSelectedUser.name,
              email: bulkSelectedUser.email,
              profilePhoto: bulkSelectedUser.profilePhoto,
            },
          }));

        const unassignedTasks = selectedTasks.filter(
          (task: any) =>
            !task?.assignee || task.assignee._id === bulkSelectedUser?._id,
        );

        this.openReassignmentReviewModal(
          alreadyAssignedTasks,
          unassignedTasks,
          bulkSelectedUser,
          {
            status: cleanedFormData.status,
            risk: cleanedFormData.risk,
            priority: cleanedFormData.priority,
            startDate: cleanedFormData.startDate,
            dueDate: cleanedFormData.dueDate,
            comment: cleanedFormData.comment,
          },
        );
        return;
      } else {
        // ✅ CASE 2: No assignee OR assignee not changed → direct submit
        const payload = {
          formId: this.activeModalContext.formID,
          data: selectedTasks.map((item: any) => {
            const record: any = {
              recordId: item._id,
              parent: parentTaskID || '',
            };

            Object.entries(formData).forEach(([key, value]) => {
              if (value === '' || value === null || value === undefined) return;

              // 🔥 Only include assignee if selected
              if (key === 'assignee' && bulkSelectedUser) {
                record.assignee = {
                  _id: bulkSelectedUser._id,
                  name: bulkSelectedUser.name,
                  email: bulkSelectedUser.email,
                  profilePhoto: bulkSelectedUser.profilePhoto,
                };
                record.assigned = bulkSelectedUser.email;
              } else if (key !== 'assignee' && key !== fieldNameForAssign) {
                record[key] = value;
              }
            });

            return record;
          }),
        };

        submitPayload(payload, cleanedFormData, false, 'bulk');
        return;
      }
    }

    // ---------------- reassignUpdate ------------------------------
    if (this.activeModalContext?.reassignUpdate == true) {
      const selectedUser = this.activeModalContext.currentAssignee;

      const { status, risk, priority, startDate, dueDate, comment } =
        this.activeModalContext;

      // const selectedIds: string[] = this.saveForm.get('tasks')?.value || [];
      const selectedIds: string[] =
        this.saveForm.get('tasks')?.value ||
        this.saveForm.get('subTasks')?.value ||
        [];
      const alreadyAssignedTasks =
        this.activeModalContext.alreadyAssignedTasks || [];

      const unassignedTasks = this.activeModalContext.unassignedTasks || [];

      const selectedReassignedTasks = alreadyAssignedTasks.filter((task: any) =>
        selectedIds.includes(task._id),
      );

      const finalTasks = [...selectedReassignedTasks, ...unassignedTasks];

      if (!finalTasks.length) return;

      const payload = {
        formId: this.activeModalContext.formID,
        data: finalTasks.map((item: any) => {
          const record: any = {
            recordId: item._id,
            parent: parentTaskID || '',
            assignee: {
              _id: selectedUser._id,
              name: selectedUser.name,
              email: selectedUser.email,
              profilePhoto: selectedUser.profilePhoto,
            },
            assigned: selectedUser.email,
          };

          // 🔥 Only add if value exists (not blank / null / undefined)
          if (status !== undefined && status !== null && status !== '')
            record.status = status;

          if (risk !== undefined && risk !== null && risk !== '')
            record.risk = risk;

          if (priority !== undefined && priority !== null && priority !== '')
            record.priority = priority;

          if (startDate !== undefined && startDate !== null && startDate !== '')
            record.startDate = startDate;

          if (dueDate !== undefined && dueDate !== null && dueDate !== '') {
            const trimmedDue = String(dueDate).trim();
            const timePart = new Date().toISOString().split('T')[1];
            record.dueDate = /^\d{4}-\d{2}-\d{2}$/.test(trimmedDue)
              ? `${trimmedDue}T${timePart}`
              : trimmedDue;
          }
          if (comment !== undefined && comment !== null && comment !== '')
            record.comment = comment;
          return record;
        }),
      };

      submitPayload(payload, null, false, 'reassign');
      return;
    }

    if (
      this.nodeId === '6a143360ca440a759a89fa08' ||
      this.formData?.formFields?.[0]?.formId === '6a143360ca440a759a89fa08' ||
      this.activeModalContext?.clickedButton === 'EDIT'
    ) {
      const userItem =
        this.activeModalContext?.item || this.activeModalContext || {};

      const roleField = this.formData?.formFields?.find(
        (f: any) => f.fieldName === 'role',
      );
      const apiRoleFieldVal = roleField?.value;
      const initialApiRole =
        this.initialRoleFromResponse ||
        (Array.isArray(apiRoleFieldVal)
          ? apiRoleFieldVal.length > 0
            ? apiRoleFieldVal[0]
            : null
          : apiRoleFieldVal) ||
        (typeof userItem.role === 'object'
          ? Array.isArray(userItem.role)
            ? userItem.role[0]
            : userItem.role
          : null);

      let currentRole =
        cleanedFormData['role.role'] !== undefined
          ? cleanedFormData['role.role']
          : cleanedFormData.role !== undefined
            ? cleanedFormData.role
            : userItem.role;

      if (Array.isArray(currentRole) && currentRole.length > 0) {
        currentRole = currentRole[0];
      }

      let roleValue: any;

      if (initialApiRole && typeof initialApiRole === 'object') {
        const isObjectMatch =
          currentRole &&
          typeof currentRole === 'object' &&
          (currentRole === initialApiRole ||
            (currentRole._id && currentRole._id === initialApiRole._id) ||
            (currentRole.id &&
              currentRole.id === initialApiRole.id &&
              !currentRole._id) ||
            (currentRole.role &&
              currentRole.role === initialApiRole.role &&
              !currentRole._id));

        const isStringMatch =
          typeof currentRole === 'string' &&
          (currentRole === initialApiRole.role ||
            currentRole === initialApiRole.name ||
            currentRole === initialApiRole._id ||
            currentRole === initialApiRole.id);

        const isUnchanged =
          !this.saveForm?.get('role')?.dirty &&
          (isObjectMatch ||
            isStringMatch ||
            currentRole === undefined ||
            currentRole === null);

        if (isUnchanged || isObjectMatch || isStringMatch) {
          roleValue = initialApiRole;
        } else {
          if (currentRole && typeof currentRole === 'object') {
            roleValue = currentRole;
          } else {
            const matched = this.findRoleOption(currentRole, roleField);
            roleValue = matched || currentRole;
          }
        }
      } else {
        if (currentRole && typeof currentRole === 'object') {
          roleValue = currentRole;
        } else {
          const matched = this.findRoleOption(currentRole, roleField);
          roleValue = matched || currentRole;
        }
      }

      const payload: any = {
        ...(userItem.item || userItem),
        ...cleanedFormData,
        _id:
          this.recordIDs && this.recordIDs !== 'add'
            ? this.recordIDs
            : userItem._id || userItem.id,
        role: roleValue,
        fullName:
          cleanedFormData.fullName ||
          userItem.fullName ||
          userItem.name ||
          cleanedFormData.name,
      };

      delete payload['role.role'];
      delete payload.nodeId;
      delete payload.recordID;
      delete payload.clickedButton;
      delete payload.item;

      submitPayload(payload, cleanedFormData);
      return;
    }

    if (this.recordIDs) {
      // ✅ Override userID field
      if (cleanedFormData.hasOwnProperty('userID')) {
        cleanedFormData['userID'] = this.profileResponse?.email || '';
      }
      const payload = {
        formId: this.formData?.formFields?.[0]?.formId,
        recordID: this.recordIDs != 'add' ? this.recordIDs : '',
        data: cleanedFormData,
      };
      submitPayload(payload, cleanedFormData);
      return;
    }
  }

  openReassignmentReviewModal(
    alreadyAssignedTasks: any[],
    unassignedTasks: any[],
    selectedUser: any,
    changedValues: any,
  ) {
    if (alreadyAssignedTasks && alreadyAssignedTasks.length > 0) {
      this.openReassigneModal.emit({
        tasksCount: alreadyAssignedTasks.length,
        alreadyAssignedTasks,
        unassignedTasks,

        currentAssignee: {
          _id: selectedUser._id,
          name: selectedUser.name,
          email: selectedUser.email,
          profilePhoto: selectedUser.profilePhoto,
        },

        oldAssignee: alreadyAssignedTasks[0]?.previousAssignee || null,

        // 🔥 PASS CHANGED VALUES FOR NEXT MODAL
        status: changedValues?.status,
        risk: changedValues?.risk,
        priority: changedValues?.priority,
        startDate: changedValues?.startDate,
        dueDate: changedValues?.dueDate,
        comment: changedValues?.comment,
      });
    }
  }

  /**
   * Recursively replaces {{placeholders}} in an object using provided context values.
   */
  replacePlaceholders(obj: any, context: any): any {
    if (typeof obj === 'string') {
      return obj.replace(/{{(.*?)}}/g, (_, key) => context[key.trim()] || '');
    }
    if (Array.isArray(obj)) {
      return obj.map((v) => this.replacePlaceholders(v, context));
    }
    if (typeof obj === 'object' && obj !== null) {
      const out: any = {};
      for (const k of Object.keys(obj)) {
        out[k] = this.replacePlaceholders(obj[k], context);
      }
      return out;
    }
    return obj;
  }

  /**
   * Opens the OAuth authentication URL in a new browser tab.
   */
  navigateOAuth(sseConfig: any, formId: any) {
    let authUrlTemplate = sseConfig?.integration?.authUrl;
    const catCode =
      this.activeModalContext?.selectedOption?.categoryCode ||
      this.activeModalContext?.categoryCode ||
      '';
    const recId = this.recordID || this.activeModalContext?.recordID || '';
    let authUrl = authUrlTemplate
      .replace('{{base}}', this.endpoint)
      .replace(/\{\{categoryCode\}\}/g, catCode)
      .replace(/\{\{integrationProfileRecordID\}\}/g, String(recId))
      .replace(/\{\{integrationProfileRecordId\}\}/g, String(recId));
    const accessToken = this.auth.token;
    const separator = authUrl.includes('?') ? '&' : '?';
    authUrl += `${separator}at=${encodeURIComponent(accessToken)}`;
    window.open(authUrl, '_blank');
  }

  /**
   * Prepares workflow data and triggers workflow instance update.
   */
  saveWorkflow(isRetry: boolean = false) {
    this.updatedWorkflow = {
      ...this.workflowData,
      startNodeId: this.nodeId,
      nodes: [...this.workflowData.nodes],
    };

    const workflowId = this.workflowData?._id || this.workflowId;
    if (!workflowId) {
      return;
    }
    const apiUrl = `/api/v1/workflow/instances/${workflowId}`;
    this.updateInstance(apiUrl, this.updatedWorkflow, true, isRetry);
  }

  /**
   * Updates the workflow instance and resets the form on success.
   */
  updateInstance(
    apiUrl: any,
    updatedWorkflow: any,
    isSubmit: boolean,
    isRetry: boolean = false,
  ) {
    this.workflowService
      .updateWorkflowInstance(apiUrl, updatedWorkflow)
      .subscribe({
        next: (resp) => {
          if (isSubmit == true) {
            this.formSaved.emit({
              success: true,
              formId: this.nodeId,
              recordId: resp?.data?._id || resp?._id,
            });
            if (!isRetry) {
              setTimeout(() => this.saveForm?.reset(), 200);
            }
          }
        },
        error: (err) => {
          const status = err.status;
          this.handleWorkflowTransition(status);
        },
      });
  }

  /*** Handle workflow transition based on the status */
  handleWorkflowTransition(status: number) {
    const node = this.workflowData?.nodes?.find(
      (n: any) => n._id === this.nodeId,
    );

    if (!node?.next?.length) return;

    const transitions = node.next[0].condition;

    for (const condition of transitions) {
      const apiCondition = condition.conditions?.find(
        (c: any) => c.type === 'api' && c.value === 'status',
      );

      if (apiCondition?.equals?.includes(status)) {
        this.nodeId = condition.targetValue;

        // optionally update startNodeId
        this.workflowData.startNodeId = condition.targetValue;

        break;
      }
    }
  }

  /** Validate component selection on click of button */
  validateCustomComponents(): boolean {
    let isValid = true;

    if (this.DomainWithTagsComponent) {
      const hasTags = this.DomainWithTagsComponent.inputWithTags.length > 0;
      const control = this.saveForm.get(
        this.DomainWithTagsComponent.fields.fieldName,
      );

      if (!hasTags) {
        this.DomainWithTagsComponent.showError =
          'Please add at least one domain';
        isValid = false;
        control?.setErrors({ required: true });
      } else {
        this.DomainWithTagsComponent.showError = '';
        control?.setErrors(null);
        if (control?.errors) {
          control.setErrors(null);
        }
      }
    }
    if (this.ProjectsCardComponent) {
      isValid = this.ProjectsCardComponent.validateSelection() && isValid;
    }
    if (this.CheckboxTypeThreeComponent) {
      isValid = this.CheckboxTypeThreeComponent.validateSelection() && isValid;
    }
    if (this.DomainInputComponent) {
      isValid = this.DomainInputComponent.showErrorMessage() && isValid;
    }
    this.inputSearchFields?.forEach((fieldComp: InputSearchFieldsComponent) => {
      const valid = fieldComp.validateSelection();
      if (!valid) isValid = false;
    });
    this.inputSearchIntegrations?.forEach(
      (fieldComp: InputSearchIntegrationComponent) => {
        const valid = fieldComp.validateSelection();
        if (!valid) isValid = false;
      },
    );
    return isValid;
  }

  /*** Utility to exclude internal fields like 'otpArray' */
  filterFormValue(form: FormGroup, excludeKeys: string[]) {
    const rawValue = form.getRawValue();
    const cleaned: any = {};
    Object.keys(rawValue).forEach((key) => {
      if (!excludeKeys.includes(key)) {
        cleaned[key] = rawValue[key];
      }
    });
    return cleaned;
  }

  findRoleOption(roleValue: any, roleField?: any): any {
    if (!roleValue) return null;
    if (typeof roleValue === 'object' && !Array.isArray(roleValue)) {
      return roleValue;
    }
    const valStr = String(Array.isArray(roleValue) ? roleValue[0] : roleValue);

    const allOptions: any[] = [];
    if (this.dropdownSelect) {
      this.dropdownSelect.forEach((ds: any) => {
        if (
          (ds?.fields?.fieldName === 'role' ||
            ds?.fields?.fieldName === 'roles') &&
          Array.isArray(ds?.fieldsData)
        ) {
          allOptions.push(...ds.fieldsData);
        }
      });
    }
    if (this.dropdownWithSearch) {
      this.dropdownWithSearch.forEach((ds: any) => {
        if (
          (ds?.fields?.fieldName === 'role' ||
            ds?.fields?.fieldName === 'roles') &&
          Array.isArray(ds?.fieldsData)
        ) {
          allOptions.push(...ds.fieldsData);
        }
      });
    }
    if (Array.isArray(roleField?.options?.staticOptions)) {
      allOptions.push(...roleField.options.staticOptions);
    }
    if (Array.isArray(this.activeModalContext?.rolesList)) {
      allOptions.push(...this.activeModalContext.rolesList);
    }

    const matched = allOptions.find((opt: any) => {
      if (!opt) return false;
      if (typeof opt === 'string') return opt === valStr;
      return (
        opt._id === valStr ||
        opt.id === valStr ||
        opt.role === valStr ||
        opt.name === valStr
      );
    });

    return matched || null;
  }

  /** Submit request payload in the api with updated workflow data*/
  submitFormViaApi(
    payload: any,
    cleanedFormData: any,
    skipWorkflowSave?: boolean,
    operationType?: 'bulk' | 'reassign' | null,
  ): void {
    this.isLoading = true;
    const apiEndpoint = this.endpoint;
    let method = this.formData?.apiIntegration?.apiMethod || '';

    const currentNode = this.workflowData?.nodes?.find(
      (n: any) => n._id === this.nodeId,
    );
    if (currentNode && currentNode.recordId && currentNode.recordId !== '0') {
      if (!payload.recordId) {
        payload.recordId = currentNode.recordId;
      }
    }
    if (payload && !Array.isArray(payload) && payload.recordId === '0') {
      delete payload.recordId;
    }

    let url = this.formData?.apiIntegration?.apiUrl || '';
    if (url.includes('/form/data/multiple')) {
      method = 'POST';
    }
    url = this.formService.replaceTemplateTokens(url, {
      api_endpoint: apiEndpoint,
      formID: payload.formId,
      recordID: payload.recordID,
    });

    if (this.activeModalContext?.deleteType === 'subnode') {
      const subnodeName = this.activeModalContext?.domain;

      const urlObj = new URL(url, window.location.origin);

      urlObj.searchParams.set('mode', 'array');
      urlObj.searchParams.set('path', 'subnodes');
      urlObj.searchParams.set('domain', subnodeName);

      url = urlObj.toString();
    }
    if (
      this.nodeId === '6a143360ca440a759a89fa08' ||
      payload?.formId === '6a143360ca440a759a89fa08' ||
      this.activeModalContext?.clickedButton === 'EDIT'
    ) {
      delete payload['role.role'];
      if (payload.data) {
        delete payload.data['role.role'];
      }
      if (Array.isArray(payload.role)) {
        payload.role = payload.role.length > 0 ? payload.role[0] : null;
      }
      if (payload.data && Array.isArray(payload.data.role)) {
        payload.data.role =
          payload.data.role.length > 0 ? payload.data.role[0] : null;
      }
      if (
        payload.data &&
        payload.role &&
        (!payload.data.role || typeof payload.data.role !== 'object')
      ) {
        payload.data.role = payload.role;
      }
      if (
        payload.status === 'IN-ACTIVE' ||
        payload.status == 'SUSPENDED' ||
        payload.status == 'ARCHIEVE' ||
        payload.status == 'ARCHIVED'
      ) {
        payload.status = 'ACTIVE';
      }
      if (
        (payload.data && payload.data.status === 'IN-ACTIVE') ||
        payload.data?.status == 'SUSPENDED' ||
        payload.data?.status == 'ARCHIEVE' ||
        payload.data?.status == 'ARCHIVED'
      ) {
        payload.data.status = 'ACTIVE';
      }
    }
    if (
      (payload &&
        (payload.formId === '6a143253ca440a759a89f9ff' ||
          payload.formId === '6878d3800453556c08933e90' ||
          payload.formId === FORM_ID.ADD_USER ||
          payload.formId === FORM_ID.USERS)) ||
      this.nodeId === '6a143253ca440a759a89f9ff' ||
      this.nodeId === FORM_ID.ADD_USER
    ) {
      delete payload['role.role'];
      if (Array.isArray(payload.role)) {
        payload.role = payload.role.length > 0 ? payload.role[0] : null;
      }
      // payload.formId = FORM_ID.USERS;
      if (payload.data) {
        payload.data.contactType = 'Others';
        payload.data.userType = 'Member';
        payload.data.source = 'Admin';
        delete payload.data.formId;
        delete payload.data.formID;
        delete payload.data['role.role'];
        if (Array.isArray(payload.data.role)) {
          payload.data.role =
            payload.data.role.length > 0 ? payload.data.role[0] : null;
        }
        if (
          payload.data.department &&
          !Array.isArray(payload.data.department)
        ) {
          payload.data.department = [payload.data.department];
        }
      }
    }
    if (payload && payload.formId === '6a0edb062db4b8fda5f347ad') {
      if (payload.data) {
        payload.data.userCreated = true;
      }
      payload.userCreated = true;
    }
    if (
      payload &&
      (payload.formId === '6a6310c80e3b3a9926943566' ||
        this.nodeId === '6a6310c80e3b3a9926943566' ||
        this.formData?.formFields?.[0]?.formId === '6a6310c80e3b3a9926943566')
    ) {
      if (payload.data && typeof payload.data === 'object') {
        if (Array.isArray(payload.data)) {
          payload.data.forEach((item: any) => {
            if (item && typeof item === 'object') {
              Object.keys(item).forEach((k) => {
                if (
                  typeof item[k] === 'string' &&
                  item[k].includes('{{integrationProfileRecordId}}')
                ) {
                  item[k] = item[k].replace(
                    /\{\{integrationProfileRecordId\}\}/g,
                    '6a630b2a0e3b3a9926943534',
                  );
                }
              });
            }
          });
        } else {
          Object.keys(payload.data).forEach((k) => {
            if (
              typeof payload.data[k] === 'string' &&
              payload.data[k].includes('{{integrationProfileRecordId}}')
            ) {
              payload.data[k] = payload.data[k].replace(
                /\{\{integrationProfileRecordId\}\}/g,
                '6a630b2a0e3b3a9926943534',
              );
            }
          });
          this.formFields?.forEach((f: any) => {
            if (
              f?.fieldName &&
              typeof f.defaultValue === 'string' &&
              (f.defaultValue === '{{integrationProfileRecordId}}' ||
                f.defaultValue.includes('{{integrationProfileRecordId}}'))
            ) {
              payload.data[f.fieldName] = '6a630b2a0e3b3a9926943534';
            }
          });
        }
      }
    }
    console.log(payload);
    this.formService.submitFormData({ url, method }, payload).subscribe({
      next: (res) => {
        this.formSaved.emit({
          success: true,
          formId: this.nodeId,
          recordId: res?.data?._id,
        });
        if (res.success) {
          this.isLoading = false;
          if (this.nodeId == '6a6310c80e3b3a9926943568') {
            this.toaster.success('Wazuh connection initiated', 'Success', {
              messageClass: 'addMessage',
              titleClass: 'addCss',
            });
          } else if (this.formData?.apiIntegration?.apiSuccessMessage != '') {
            if (this.nodeId == '69c5004fcc0290f4b663482a') {
              this.toaster.success('Location added successfully', 'Success', {
                messageClass: 'addMessage',
                titleClass: 'addCss',
              });
            } else
              this.toaster.success(
                this.formData?.apiIntegration?.apiSuccessMessage,
                'Success',
                {
                  messageClass: 'addMessage',
                  titleClass: 'addCss',
                },
              );
            if (operationType === 'bulk' || operationType === 'reassign') {
              this.openSuccessModal.emit();
            }
          } else {
            this.toaster.success(res.message, 'Success', {
              messageClass: 'addMessage',
              titleClass: 'addCss',
            });
          }
        }
        const InsertedID = res?.data?._id;
        const domainField = this.formFields.find(
          (field: any) => field.fieldType === 'domainWithInputTags',
        );
        if (domainField) {
          setTimeout(() => {
            this.DomainRowsComponent.forEach((comp) => comp.getData());
          }, 200);
        }

        const node = this.workflowData?.nodes?.find(
          (n: any) => n._id === this.nodeId,
        );
        if (node) {
          if (!node.recordId || node.recordId.trim() === '') {
            node.recordId = InsertedID;
          }
        }

        const hasAddDomainField = Object.keys(cleanedFormData || {}).includes(
          'domainWithInputTags',
        );
        if (!hasAddDomainField && !skipWorkflowSave) {
          const updatedWorkflow = {
            ...this.workflowData,
            startNodeId: this.nodeId,
            // nodes: [...this.workflowData?.nodes],
            nodes: Array.isArray(this.workflowData?.nodes)
              ? [...this.workflowData.nodes]
              : [],
            stepperItems: this.workflowData?.stepperItems,
          };

          const workflowId = this.workflowData?._id || this.workflowId;
          if (!workflowId) return;
          this.isLoading = false;
          const apiUrl = `/api/v1/workflow/instances/${workflowId}`;
          this.updateInstance(apiUrl, updatedWorkflow, false);
          this.isLoading = false;
        }

        setTimeout(() => {
          this.saveForm.reset();
        }, 200);
      },
      error: (err) => {
        this.isLoading = false;
        this.toaster.error(err.error.message, 'Error', {
          messageClass: 'addMessage',
          titleClass: 'addCss',
        });
      },
    });
    this.skipWorkflowSave = false;
  }

  resetSearchInputs() {
    this.inputSearchFields?.forEach((input) => input.resetSearch());
  }

  resetSearchInput() {
    this.saveForm.reset();
    this.inputSearchFields?.forEach((input) => input.resetSearch());
  }

  resetFilterForm() {
    this.saveForm.reset();
  }

  resetFilterFormControl(fieldName: string): void {
    if (!this.saveForm) {
      return;
    }

    let actualFieldName = fieldName;
    if (fieldName === 'mappedStandards.standardName') {
      actualFieldName = 'mappedStandards_standardName';
    }

    let control = this.saveForm.get(actualFieldName);
    if (!control) {
      if (actualFieldName === 'domain') control = this.saveForm.get('domainSubdomainMappings');
      else if (actualFieldName === 'domainSubdomainMappings') control = this.saveForm.get('domain');
      else if (actualFieldName === 'status') control = this.saveForm.get('taskStatus');
      else if (actualFieldName === 'taskStatus') control = this.saveForm.get('status');
      else if (actualFieldName === 'priority') control = this.saveForm.get('taskPriority');
      else if (actualFieldName === 'taskPriority') control = this.saveForm.get('priority');
      else if (actualFieldName === 'risk') control = this.saveForm.get('riskStatus');
      else if (actualFieldName === 'riskStatus') control = this.saveForm.get('risk');
      else if (actualFieldName === 'assigned') control = this.saveForm.get('assignedUser');
      else if (actualFieldName === 'assignedUser') control = this.saveForm.get('assigned');
      else if (actualFieldName === 'impact') control = this.saveForm.get('taskImpact') || this.saveForm.get('riskImpact');
      else if (actualFieldName === 'probability') control = this.saveForm.get('taskProbability') || this.saveForm.get('riskProbability');
    }

    if (control) {
      control.reset();
    } else {
      console.warn(`Control "${actualFieldName}" not found in saveForm.`);
    }
  }

  resetFilterActionableControl(fieldName: string): void {
    if (!this.saveForm) {
      return;
    }

    let control = this.saveForm.get(fieldName);
    if (!control) {
      if (fieldName === 'assetType') control = this.saveForm.get('asset_type');
      else if (fieldName === 'asset_type') control = this.saveForm.get('assetType');
      else if (fieldName === 'risk') control = this.saveForm.get('riskStatus');
      else if (fieldName === 'riskStatus') control = this.saveForm.get('risk');
      else if (fieldName === 'impact') control = this.saveForm.get('riskImpact');
      else if (fieldName === 'status') control = this.saveForm.get('actionableStatus');
    }

    if (control) {
      control.reset();
      if (fieldName === 'dateRange') {
        this.saveForm.get('startDate')?.reset();
        this.saveForm.get('endDate')?.reset();
      }
    } else {
      console.warn(`Control "${fieldName}" not found in saveForm.`);
    }
  }

  resetComment(fieldName: any) {
    if (!this.saveForm) {
      return;
    }
    const control = this.saveForm.get(fieldName);
    if (control) {
      control.reset();
    }
  }

  resetData(fieldName: any) {
    if (!this.saveForm) {
      return;
    }
    const control = this.saveForm.get(fieldName);
    if (control) {
      control.reset();
    }
  }

  onLoaderChange(value: boolean) {
    this.isShowButton = value;
  }

  updateButtonState() {
    const hasDataViewLoader = this.formFields.some(
      (field: any) => field.componentId === 'dataViewWithLoader',
    );

    if (
      hasDataViewLoader ||
      this.disableFields === true ||
      this.disableFields === 'true'
    ) {
      this.isShowButton = false;
    } else {
      this.isShowButton = true;
    }
  }

  checkError() {
    this.checkPollingServiceForError.emit({ value: true });
  }

  resetForms() {
    this.saveForm.reset();
  }

  stopChildPolling() {
    if (this.dataView) {
      this.dataView.stopPolling();
    }
  }

  // @HostListener('document:keyup.enter', ['$event'])
  // handleEnterKey(event: KeyboardEvent): void {
  //   if (!this.activeModalContext || !this.saveForm) return;

  //   // 🚨 Only allow Enter for the modal that owns this form
  //   if (this.activeModalContext?.nodeId !== this.nodeId) return;

  //   if (this.isLoading || !this.isShowButton) return;
  //   if (event.repeat) return;

  //   const target = event.target as HTMLElement;

  //   // Ignore textarea
  //   if (target?.tagName === 'TEXTAREA') return;

  //   // Ignore tag input
  //   if (target?.closest('[data-input-with-tags]')) return;

  //   // Ignore dropdown search
  //   if (target?.closest('[data-dropdown-search]')) return;

  //   event.preventDefault();
  //   event.stopPropagation();

  //   // Validate domain tags
  //   if (
  //     this.DomainWithTagsComponent &&
  //     this.DomainWithTagsComponent.inputWithTags.length === 0
  //   ) {
  //     this.DomainWithTagsComponent.showError = 'Please add at least one domain';

  //     const control = this.saveForm.get(
  //       this.DomainWithTagsComponent.fields.fieldName,
  //     );

  //     control?.setErrors({ required: true });
  //     return;
  //   }

  //   const submitBtn = this.footerFields?.find(
  //     (btn: any) => !this.isNonSubmitAction(btn) && !btn.disabled,
  //   );

  //   if (!submitBtn) return;

  //   setTimeout(() => {
  //     this.saveForm.updateValueAndValidity();
  //     this.onSave(submitBtn);
  //   }, 0);
  // }

  isNonSubmitAction(btn: any): boolean {
    // If clickAction is NOT present, this is a submit button
    if (!btn || !btn.clickAction) {
      return false;
    }
    const nonSubmitActions = [
      'modalClose',
      'closeModal',
      'cancel',
      'goToPreviousStep',
      'navigate',
      'back',
      'clearAll',
      'clearButton',
    ];

    return nonSubmitActions.includes(btn.clickAction);
  }

  submitFromOutside(): void {
    if (this.isLoading) return;

    // mark + validate
    this.saveForm.markAllAsTouched();
    if (!this.saveForm.valid) return;

    // reuse existing logic
    this.onSave({ clickAction: '__submit__' });
  }

  setFirstFocusField() {
    if (!this.formFields?.length) {
      this.firstFocusFieldName = null;
      return;
    }

    const firstField = this.formFields[0];

    this.firstFocusFieldName =
      this.visibleFields[firstField.fieldName] === false
        ? null
        : firstField.fieldName;
  }

  handleDomainSubmit(): void {
    if (
      !this.DomainWithTagsComponent ||
      this.DomainWithTagsComponent.inputWithTags.length === 0
    ) {
      this.DomainWithTagsComponent.showError = 'Please add at least one domain';
      return;
    }

    // ✅ convert to lowercase + trim
    this.domainTagsForSubmit = this.DomainWithTagsComponent.inputWithTags.map(
      (domain: string) => domain.trim().toLowerCase(),
    );

    const domainField = this.formFields.find(
      (f: any) => f.fieldType === 'domainWithInputTags',
    );

    const domainKey = domainField?.fieldName;

    const submitBtn = this.footerFields?.find(
      (btn: any) => !this.isNonSubmitAction(btn) && !btn.disabled,
    );

    if (submitBtn) {
      this.onSave(submitBtn);

      // ✅ clear only input UI control
      if (domainKey) {
        this.saveForm.get(domainKey)?.setValue('', { emitEvent: false });
      }
    }
  }

  onEnterSubmit(e: any) {
    // Optional: avoid submitting when typing in a textarea unless Ctrl/Cmd+Enter
    const tag = (e.target as HTMLElement)?.tagName?.toLowerCase();
    if (tag === 'textarea' && !e.ctrlKey && !e.metaKey) return;

    e.preventDefault();
    this.handleSubmit();
  }

  private readonly applyBtnMeta = {
    componentId: 'applyButton',
    clickAction: 'submit',
  };
  handleSubmit() {
    // This is triggered by Enter or clicking a type="submit" button
    this.onSave(this.applyBtnMeta);
  }

  getProfileDetails() {
    let token = localStorage.getItem('accessToken');
    this.authService.getProfile(token).subscribe({
      next: (data) => {
        this.profileResponse = data.data;
      },
      error: (err) => console.error('Error', err),
    });
  }

  get roleAccessTopFields(): any[] {
    return [
      ...this.getLayoutFields('top').filter(
        (field: any) => this.getLayoutColSpan(field) <= 6,
      ),
      ...this.getLayoutFields('top-left-stack'),
    ];
  }

  get roleAccessFullTopFields(): any[] {
    return this.getLayoutFields('top').filter(
      (field: any) => this.getLayoutColSpan(field) > 6,
    );
  }

  get roleAccessBottomFields(): any[] {
    return this.getLayoutFields('bottom');
  }

  get hasRoleAccessLayout(): boolean {
    return (
      this.formFields?.some(
        (field: any) => field?.componentId === 'accessComponent',
      ) &&
      this.formFields?.some((field: any) => field?.fieldName === 'roleStatus')
    );
  }

  isRoleAccessLayoutField(field: any): boolean {
    return !!field?.uiOptions?.layout?.section;
  }

  getLayoutColClass(field: any): string {
    const colSpan = this.getLayoutColSpan(field);

    if (colSpan <= 6) {
      return 'role-access-layout__field role-access-layout__field--half';
    }

    return 'role-access-layout__field role-access-layout__field--full';
  }

  private getLayoutFields(section: string): any[] {
    return (this.formFields ?? []).filter(
      (field: any) => field?.uiOptions?.layout?.section === section,
    );
  }

  private getLayoutColSpan(field: any): number {
    return Number(field?.uiOptions?.layout?.colSpan ?? 12);
  }

  isTwoColumnLayout(): boolean {
    if (!this.formFields?.length) return false;

    const allowed = ['dropdownWithSearch', 'dropdownSelect', 'inputTextField'];

    return this.formFields.every((field: any) =>
      allowed.includes(field.componentId),
    );
  }

  hasFilterDropdown(): boolean {
    return (
      this.formFields?.some(
        (field: any) => field.componentId === 'filterDropdown',
      ) || false
    );
  }

  hasUserInvite(): boolean {
    return (
      this.formFields?.some(
        (field: any) => field.componentId === 'userInvite',
      ) || false
    );
  }

  registerCustomFieldDependencyWatchers() {
    this.formFields?.forEach((field: any) => {
      if (Array.isArray(field.fieldDependencies)) {
        field.fieldDependencies.forEach((dependency: any) => {
          const triggerFieldName = dependency.trigger;
          if (
            triggerFieldName &&
            triggerFieldName !== 'onValueChange' &&
            triggerFieldName !== 'isTaskMapped'
          ) {
            // const triggerControl = this.saveForm.get(triggerFieldName);
            const triggerControl =
              this.saveForm.controls[triggerFieldName] ||
              this.saveForm.get(triggerFieldName);
            if (triggerControl) {
              triggerControl.valueChanges
                .pipe(takeUntil(this.formRebuild$ || this.destroy$))
                .subscribe((selectedValue: any) => {
                  this.executeFieldDependencyActions(dependency, selectedValue);
                });
              // Run initially if it already has a value
              if (triggerControl.value) {
                this.executeFieldDependencyActions(
                  dependency,
                  triggerControl.value,
                );
              }
            }
          }
        });
      }
    });
  }

  executeFieldDependencyActions(dependency: any, selectedValue: any) {
    if (!selectedValue) return;

    const applyActions = (valueObj: any) => {
      const conditionBlocks = Array.isArray(dependency.condition)
        ? dependency.condition
        : Array.isArray(dependency.conditions)
          ? dependency.conditions
          : [];

      conditionBlocks.forEach((condBlock: any) => {
        const conditions = condBlock.conditions || condBlock.condition || [];
        const normalizedConditions = Array.isArray(conditions)
          ? conditions
          : [conditions];

        const isMatched = normalizedConditions.every((cond: any) => {
          if (cond.operator === 'isNotNull') {
            return (
              valueObj !== null && valueObj !== undefined && valueObj !== ''
            );
          }
          return true;
        });

        if (isMatched && Array.isArray(condBlock.actions)) {
          condBlock.actions.forEach((action: any) => {
            const targetField = action.targetField;
            let targetControl =
              this.saveForm.controls[targetField] ||
              this.saveForm.get(targetField);

            if (!targetControl && targetField) {
              const matchKey = Object.keys(this.saveForm.controls || {}).find(
                (k) => k.toLowerCase() === targetField.toLowerCase(),
              );
              if (matchKey) {
                targetControl =
                  this.saveForm.controls[matchKey] ||
                  this.saveForm.get(matchKey);
              }
            }
            if (!targetControl) return;

            if (action.actionType === 'setValueFromSelected') {
              const key = action.value;
              let finalValue = '';
              const isRefreshTokenUrl =
                targetField?.toLowerCase() === 'config.refreshtokenurl' ||
                targetField?.toLowerCase() === 'refreshtokenurl';

              if (typeof key === 'string') {
                let resolvedKey = key;
                if (
                  (resolvedKey === 'authTokenPath' ||
                    resolvedKey === 'AccountsURL' ||
                    (isRefreshTokenUrl && !valueObj[resolvedKey])) &&
                  !valueObj[resolvedKey] &&
                  valueObj['baseTokenPath']
                ) {
                  resolvedKey = 'baseTokenPath';
                }
                if (resolvedKey.includes('{{') && resolvedKey.includes('}}')) {
                  finalValue = resolvedKey.replace(
                    /\{\{([^}]+)\}\}/g,
                    (match, propName) => {
                      let prop = propName;
                      if (
                        (prop === 'authTokenPath' ||
                          prop === 'AccountsURL' ||
                          (isRefreshTokenUrl && !valueObj[prop])) &&
                        !valueObj[prop] &&
                        valueObj['baseTokenPath']
                      ) {
                        prop = 'baseTokenPath';
                      }
                      if (
                        valueObj &&
                        valueObj[prop] !== undefined &&
                        valueObj[prop] !== null &&
                        valueObj[prop] !== ''
                      ) {
                        return valueObj[prop];
                      }
                      const formControlVal =
                        this.saveForm?.get(prop)?.value ||
                        this.saveForm?.get('config.' + prop)?.value ||
                        this.saveForm?.get('config.baseURL')?.value ||
                        this.saveForm?.get('config.baseUrl')?.value ||
                        this.saveForm?.get('config.baseAPIPath')?.value ||
                        this.saveForm?.get('baseURL')?.value ||
                        this.saveForm?.get('baseUrl')?.value ||
                        this.saveForm?.get('baseAPIPath')?.value;
                      if (formControlVal) {
                        return formControlVal;
                      }
                      return match;
                    },
                  );
                } else {
                  if (
                    (resolvedKey === 'authTokenPath' ||
                      resolvedKey === 'AccountsURL' ||
                      resolvedKey === 'baseTokenPath' ||
                      isRefreshTokenUrl) &&
                    !valueObj[resolvedKey] &&
                    valueObj['baseTokenPath']
                  ) {
                    finalValue = valueObj['baseTokenPath'];
                  } else {
                    finalValue =
                      valueObj[resolvedKey] !== undefined &&
                      valueObj[resolvedKey] !== null
                        ? valueObj[resolvedKey]
                        : '';
                  }
                }
              } else {
                finalValue = valueObj;
              }

              if (typeof finalValue === 'string' && !isRefreshTokenUrl) {
                const currentBase =
                  this.saveForm?.get('config.baseURL')?.value ||
                  this.saveForm?.get('config.baseUrl')?.value ||
                  this.saveForm?.get('config.baseAPIPath')?.value ||
                  this.saveForm?.get('baseURL')?.value ||
                  this.saveForm?.get('baseUrl')?.value ||
                  this.saveForm?.get('baseAPIPath')?.value ||
                  '';
                if (currentBase) {
                  const trimmedBase = String(currentBase).trim();
                  finalValue = finalValue
                    .replace(/\{\{BASE\}\}/g, trimmedBase)
                    .replace(/\{\{baseUrl\}\}/g, trimmedBase)
                    .replace(/\{\{baseURL\}\}/g, trimmedBase)
                    .replace(/\{\{baseAPIPath\}\}/g, trimmedBase);
                }
              }

              if (isRefreshTokenUrl) {
                const tokenBase =
                  valueObj?.['baseTokenPath'] ||
                  valueObj?.['authTokenPath'] ||
                  valueObj?.['AccountsURL'] ||
                  (typeof finalValue === 'string' ? finalValue : '');
                if (typeof tokenBase === 'string' && tokenBase.trim()) {
                  const cleanToken = tokenBase.trim().replace(/\/+$/, '');
                  if (cleanToken.endsWith('/oauth/v2/auth')) {
                    finalValue = cleanToken;
                  } else {
                    finalValue = `${cleanToken}/oauth/v2/auth`;
                  }
                }
              }

              targetControl.setValue(finalValue, { emitEvent: true });
            }
          });
        }
      });
    };

    if (typeof selectedValue === 'object' && selectedValue !== null) {
      applyActions(selectedValue);
      return;
    }

    const triggerField = this.formFields?.find(
      (f: any) => f.fieldName === dependency.trigger,
    );
    const source = triggerField?.options?.source;
    if (source && source.formID && source.apiUrl) {
      const apiEndpoint = this.endpoint;
      const replacements = {
        formId: source.formID,
        formID: source.formID,
        api_endpoint: apiEndpoint,
      };
      const url = this.formService.replaceTemplateTokens(
        source.apiUrl,
        replacements,
      );
      const method = source.method || 'GET';

      this.formService
        .loadData(method, url, { 'Content-Type': 'application/json' }, {}, 30)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res: any) => {
            const records = res?.data?.records || [];
            const foundOption = records.find((opt: any) => {
              return (
                opt._id === selectedValue ||
                opt.id === selectedValue ||
                opt.name === selectedValue ||
                opt.text === selectedValue ||
                opt.regionCode === selectedValue ||
                opt.regionName === selectedValue
              );
            });
            if (foundOption) {
              applyActions(foundOption);
            }
          },
          error: (err) =>
            console.error('Error fetching dependency option', err),
        });
    }
  }

  hasComponent(componentId: string): boolean {
    return (
      this.formFields?.some((f: any) => f.componentId === componentId) || false
    );
  }

  handleSendInvitation(event: {
    selectedUsers: any[];
    role: any;
    message?: string;
  }) {
    this.isLoading = true;
    let completedCount = 0;
    const total = event.selectedUsers.length;

    if (total === 0) {
      this.toaster.error(
        'Please select at least one user to invite.',
        'Warning',
        {
          messageClass: 'addMessage',
          titleClass: 'addCss',
        },
      );
      this.isLoading = false;
      return;
    }

    const hasMissingRole = event.selectedUsers.some(
      (user, idx) =>
        !user.role &&
        (!event.role ||
          (Array.isArray(event.role) &&
            !event.role[idx] &&
            !event.role.length)),
    );

    if (hasMissingRole) {
      this.toaster.error('Please select a user role.', 'Warning', {
        messageClass: 'addMessage',
        titleClass: 'addCss',
      });
      this.isLoading = false;
      return;
    }

    event.selectedUsers.forEach((user, index) => {
      const { id, initials, ...originalUser } = user;
      const roleToFormat =
        user.role ??
        (Array.isArray(event.role) ? event.role[index] : event.role);
      const roleValue = Array.isArray(roleToFormat)
        ? roleToFormat.length > 0
          ? roleToFormat[0]
          : null
        : roleToFormat;
      const deptToFormat =
        user.department !== undefined
          ? user.department
          : originalUser.department;
      const departmentValue = Array.isArray(deptToFormat)
        ? deptToFormat
        : deptToFormat !== undefined && deptToFormat !== null
          ? [deptToFormat]
          : [];

      const payload = {
        ...originalUser,
        fullName: user.name,
        email: user.email,
        invite: '',
        status: 'ACTIVE',
        role: roleValue,
        department: departmentValue,
      };
      delete (payload as any).formId;
      delete (payload as any).formID;
      delete (payload as any).message;

      this.commonService.updateUserStatus(payload).subscribe({
        next: (res) => {
          completedCount++;
          if (completedCount === total) {
            this.toaster.success('Invitations sent successfully', 'Success', {
              messageClass: 'addMessage',
              titleClass: 'addCss',
            });
            this.isLoading = false;
            this.formSaved.emit({ success: true, formId: this.nodeId });
            this.closeModal.emit();
          }
        },
        error: (err) => {
          completedCount++;
          this.toaster.error(
            `Failed to invite ${user.name}: ${err.error?.message || err.message || 'Error'}`,
            'Error',
          );
          if (completedCount === total) {
            this.isLoading = false;
            this.formSaved.emit({ success: true, formId: this.nodeId });
            this.closeModal.emit();
          }
        },
      });
    });
  }
}
